import React, { useContext, useState, useEffect } from "react";
import { Box, Typography, Menu, MenuItem, Button } from "@mui/material";
import "../../cssfiles/homepage.css";
import { useSelector, useDispatch } from "react-redux";
import {
  updatedeviceno,
  getdeviceno,
  getgatwaylist,
  updatedevicedata,
} from "../../store/device_config_data";
import { ThemeContext } from "../Homepage";
import LK_Add from "../../images/LK_Add";
import CustomButton from "../CommonComponents/CustomButton";
import CustomCancelButton from "../CommonComponents/CustomCancelButton";
import ExpandMoreOutlinedIcon from "@mui/icons-material/ExpandMoreOutlined";
import ExpandLessOutlinedIcon from "@mui/icons-material/ExpandLessOutlined";
import CustomTextField from "../CommonComponents/CustomTextField";
import CustomCheckbox from "../CommonComponents/CustomCheckbox";
import CustomDropDown from "../CommonComponents/CustomDropDown";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Divider from "@mui/material/Divider";
import LK_Delete from "../../images/LK_Delete";
import {
  devicecreate,
  devicedelete,
  getdevices,
  getgatewaylist,
  getDeviceTypesList,
  getDeviceLibraryByIdList,
  getDeviceLibraryList,
  getTagUnitsandDataTypes,
  getStorageGroupsList,
  getTagConfiguration,
} from "../../Restclient/datacollection";
import EditableTable from "../Dashboards/Graphs/Table/EditableTable";
import LK_Copy from "../../images/LK_Copy";
import LK_Select from "../../images/LK_Select";
import LK_Close from "../../images/LK_Close";
import LK_Search from "../../images/LK_Search";
// date picker
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import CustomDatePicker from "../CommonComponents/CustomDatePicker";
import CustomRadioButton from "../CommonComponents/CustomRadioButton";
import CustomDialogBox from "../CommonComponents/CustomDialogBox";
import LK_Refresh from "../../images/LK_Refresh";
import LK_Loading from "../../images/LK_Loading.gif";
import CustomToast from "../CommonComponents/CustomToast";
import { deviceconnetionStatus } from "../../Restclient/datacollection";
import CustomTooltip from "../CommonComponents/CustomTooltip";

///need move type and subtype name and id logic to back end??????????????????
/////OR MAYBE AT POINT OF SAVING
///DO we even need to store type by id or name will suffice
export default function Devices() {
  dayjs.extend(customParseFormat);
  const virtualDeviceOptions = [
    ["Normal", "false"],
    ["Virtual", "true"],
  ];
  const [virtualOption, setVirtualOption] = React.useState(virtualDeviceOptions[0][1]);
  const [cloneStatus, setCloneStatus] = React.useState(0);
  const [tagConfiguration, setTagConfiguration] = React.useState([]);
    dayjs.extend(customParseFormat);
    const filter = ["Status Connected","Status Disconnected","State Enabled","State Disabled"];
    const filterMap = {connectionstate:"Status",enable:"State"};
    // const type = ["Meter","Release","Relay","Drives","Transmitter","Sensor","Other"];
    // const subtype = [["EM101","ER300P","Nova","PQ7000","PQ8000","Quasar","WC4400","WC4405","WC4410","WC4420","WC4430","WC4440","WC5000","WC5010","WC6000","WL4400","WL4405","WL4410","WL4420","WL4430","WL4440","WL5000","WL5010","WL6000","miEnergy1Ph","miEnergy3Ph"],["MTX30","MTX35","MTX35SEC","MTX45","SR71","iTrip4","iTrip5"],["MC61CnX","etaCON","etaULTRA","iMMR"],["CX2000","FX2000","HX2000","NX2000","NX2000Plus","SX2000"],["Pressure","Level"],["Flow","Temperature","Chlorine","pH"],[]];
    const meterType = ["Plant","Consumer"];
    const phaseType = ["Single Phase","Three Phase"];
    const deviceCategory = [["Incomer","Incomer"],["Feeder","Feeder"]];

    const deviceno = useSelector(state => state.deviceconfigdata.deviceno);
    const userdetails = useSelector(state => state.logindata.userdetails);
    const projectname = useSelector(state => state.mainpagedata.selectedprojectname)
    // const subscriptionDetails = useSelector(state => state.mainpagedata.subscriptionDetails[0].FeatureList)


    const{ theme }= useContext(ThemeContext);
    const dispatch = useDispatch();
    const [openForm, setOpenForm] = React.useState(0);
    const [deleteDevice,setDeleteDevice] = React.useState(0);
    const [search, setSearch] = useState({searchText:"",filterSelected:""});
    const [deviceInfo, setDeviceInfo] = useState({organizationId:"",projectId:"",id:"",isVirtual: "false",data:{deviceName:"",serialNo:"",deviceType : "",deviceSubtype : "", meterType : meterType[0], otherDeviceType:"",accuracyClass:"",phaseType:phaseType[0],finalReading:"",deviceCategory:"Feeder",make:"",model:"",firmware:"",enable:true,description:"",commissionDate:"",calibrationDate:"",decommissionDate:"",associatedGateway:"none",parameters:[]}});
    const [required, setRequired] = React.useState(0);
    const [saveStatus, setSaveStatus] =  React.useState(0);
    const [copyStatus, setCopyStatus] = React.useState(0);
    const [deleteDeviceArr,setDeleteDeviceArr] = React.useState([]);
    const [deleteConfimed, setDeleteConfirmed] = React.useState(0);
    const [deleteSuccess, setDeleteSuccess] = React.useState(0);
    const [deleteTags, setDeleteTags] = React.useState({tagids:[]});
    const [searchList,setsearchList] = React.useState([]);
    const [ifsearching, setifSearching] = useState(0);
    const [gatewayidlist, setgatewayidlist] = useState([]);
    const [connState,setConnState]=useState([]);
    const [gatewayList, setGatewayList] = React.useState([]);
    const [deviceLibraryList, setDeviceLibraryList] = React.useState([]);
    const [type, setType] = React.useState([]); // 0 is id, 1 is name
    const [subtype, setSubtype] = React.useState([]);  // 0 is id, 1 is name
    const [unitandDatatype, setUnitandDatatype] = React.useState([]);  
    const [storageGroups, setStorageGroups] = React.useState([]);  
    const [selectLibraryDevice,setSelectLibraryDevice]=React.useState("none");
    const [selectedtypeIDlib,setSelectedtypeIDlib]=React.useState("");
    const [selectedlibList,setSelectedlibList]=React.useState(['none']);
    const [loading,setLoading]=useState(1);
    const [subscriptionvalid,setSubscriptionValid]=useState(0);
    const [disableButtons,setDisableButtons] = useState(99);
        //for disableButtons = 0, all buttons are enabled
        //for disableButtons = 99, all buttons are disabled 
        //for disableButtons = 1, only delete button  and select all and close is enabled  ///search  what about search while deleting??
        //for disableButtons = 2, only save form and close form is enabled ?

  const getTagCallback = (res) => {
    setTagConfiguration(res);
  };

  useEffect(() => {
    getDeviceTypesList(getDeviceTypesListcallback);
    // getdevices(getdevicescallback);
    getgatewaylist(getgatewaylistcallback);
    getDeviceLibraryList(getDeviceLibraryListcallback);
    getTagUnitsandDataTypes(getTagUnitsandDataTypescallback); //since its isprojrct independent once during loading is enough
    getStorageGroupsList(getStorageGroupsListcallback);
    getTagConfiguration(getTagCallback);
    setLoading(1);
  }, []);

  useEffect(() => {
    if (type.length !== 0) {
      getdevices(getdevicescallback);
      setLoading(1);
    }
  }, [type]);

  useEffect(() => {
    if (type.length !== 0 && deviceLibraryList.length !== 0) {
      const index = type[1].findIndex((val) => val === "Meter");
      const mtypeid = index !== -1 ? type[0][index] : "";
      setSelectedlibList([
        "none",
        ...deviceLibraryList
          .filter((val) => val[2] === mtypeid)
          .map((val) =>
            val[1].charAt(0) === "_" ? val[1].substring(1) : val[1],
          ),
      ]);
    }
  }, [type, deviceLibraryList]);

  useEffect(() => {
    getDeviceTypesList(getDeviceTypesListcallback);
    // getdevices(getdevicescallback);
    getgatewaylist(getgatewaylistcallback);
    getDeviceLibraryList(getDeviceLibraryListcallback);
    getStorageGroupsList(getStorageGroupsListcallback);
    setLoading(1);
  }, [projectname]);

  useEffect(() => {
    if (deleteDeviceArr.length !== 0) {
      setDisableButtons(1);
    } else {
      if (disableButtons !== 99) {
        setDisableButtons(0);
      }
    }
  }, [deleteDeviceArr]);

  function getDeviceTypesListcallback(res) {
    let temptype = [[], []];
    let tempsubtype = [[], []];
    if (res.status === 200) {
      if (res.data.type === "success") {
        if (res.data.data.length === 0) {
          // temptype=[[],[]]
          // tempsubtype = [[],[]]
        } else {
          res.data.data.map((val, index) => {
            temptype[0] = [...temptype[0], val.TypeID];
            let name = val.TypeName;
            if (name.charAt(0) === "_") {
              name = name.substring(1);
            }
            temptype[1] = [...temptype[1], name];
            tempsubtype[0] = [...tempsubtype[0], []];
            tempsubtype[1] = [...tempsubtype[1], []];
            val.SubTypeList.map((sval, sindex) => {
              tempsubtype[0][index] = [
                ...tempsubtype[0][index],
                sval.SubTypeID,
              ];
              let sname = sval.SubTypeName;
              if (sname.charAt(0) === "_") {
                sname = sname.substring(1);
              }
              tempsubtype[1][index] = [...tempsubtype[1][index], sname];
            });
          });
          setType(temptype);
          setSelectedtypeIDlib(temptype[0][0]);
          setSubtype(tempsubtype);
        }
      } else if (res.data.type === "error") {
        // handle error
      }
    } else if (res.status === 500) {
      // pop for error
    }
  }

  function getDeviceLibraryListcallback(res) {
    let temp = [["", "none", "none"]];
    if (res.status === 200) {
      res.data.devicelibrarylist.map((val, index) => {
        temp = [...temp, [val.DeviceID, val.Name, val.DeviceTypeID]];
      });
      setDeviceLibraryList(temp);
    } else if (res.status === 500) {
      // pop for error
    }
  }

  function getTagUnitsandDataTypescallback(res) {
    if (res.status === 200 && res.data.type === "success") {
      setUnitandDatatype(res.data.data);
    } else if (res.status === 500) {
      // pop for error
    }
  }

  function getStorageGroupsListcallback(res) {
    if (res.status === 200 && res.data.type === "success") {
      setStorageGroups(res.data.data);
    } else if (res.status === 500) {
      // pop for error
    }
    setLoading(0);
  }

  function getgatewaylistcallback(res) {
    let data = [];
    res.map((_val, index) => {
      data = [...data, res[index].Name];
    });
    const temp = [...data];
    temp.sort();
    dispatch(getgatwaylist(data));
    setgatewayidlist(res);
    setGatewayList(["none", ...temp]);
  }

  function alldevices(res) {
    let temp = [];
    let data;
    let meterid = "";
    // let metersubtypeid = '';
    let ismeter = 0;
    type[1].map((val, index) => {
      if (val === "Meter") {
        meterid = type[0][index];
        // metersubtypeid = subtype[0][index][0];
      }
    });
    res.map((_val, index) => {
      if (res[index].DeviceType.DeviceTypeID === meterid) {
        if (res[index].DeviceType.MeterType === "Consumer") {
          data = {
            organizationId: res[index].OrgID,
            projectId: res[index].ProjectID,
            id: res[index].DeviceID,
            isVirtual: res[index].IsVirtual,
            data: {
              deviceName: res[index].Name,
              serialNo: res[index].SN,
              deviceType: res[index].DeviceType.DeviceTypeID,
              deviceSubtype: res[index].DeviceType.DeviceSubTypeID,
              meterType: res[index].DeviceType.MeterType,
              finalReading: res[index].DeviceType.FinalReading,
              accuracyClass: res[index].DeviceType.AccuracyClass,
              phaseType: res[index].DeviceType.PhaseType,
              deviceCategory: res[index].Category,
              make: res[index].Make,
              model: res[index].Model,
              firmware: res[index].Firmware,
              enable: res[index].Enable,
              description: res[index].Description,
              commissionDate: res[index].CommissionDate,
              calibrationDate: res[index].CalibrationDate,
              decommissionDate: res[index].DecommissionDate,
              associatedGateway: res[index].GatewayID,
              parameters: res[index].Parameters,
            },
          };
        } else {
          data = {
            organizationId: res[index].OrgID,
            projectId: res[index].ProjectID,
            id: res[index].DeviceID,
            isVirtual: res[index].IsVirtual,
            data: {
              deviceName: res[index].Name,
              serialNo: res[index].SN,
              deviceType: res[index].DeviceType.DeviceTypeID,
              deviceSubtype: res[index].DeviceType.DeviceSubTypeID,
              meterType: res[index].DeviceType.MeterType,
              finalReading: res[index].DeviceType.FinalReading,
              phaseType: res[index].DeviceType.PhaseType,
              deviceCategory: res[index].Category,
              make: res[index].Make,
              model: res[index].Model,
              firmware: res[index].Firmware,
              enable: res[index].Enable,
              description: res[index].Description,
              commissionDate: res[index].CommissionDate,
              calibrationDate: res[index].CalibrationDate,
              decommissionDate: res[index].DecommissionDate,
              associatedGateway: res[index].GatewayID,
              parameters: res[index].Parameters,
            },
          };
        }
      } else {
        data = {
          organizationId: res[index].OrgID,
          projectId: res[index].ProjectID,
          id: res[index].DeviceID,
          isVirtual: res[index].IsVirtual,
          data: {
            deviceName: res[index].Name,
            serialNo: res[index].SN,
            deviceType: res[index].DeviceType.DeviceTypeID,
            deviceSubtype: res[index].DeviceType.DeviceSubTypeID,
            deviceCategory: res[index].Category,
            make: res[index].Make,
            model: res[index].Model,
            firmware: res[index].Firmware,
            enable: res[index].Enable,
            description: res[index].Description,
            commissionDate: res[index].CommissionDate,
            calibrationDate: res[index].CalibrationDate,
            decommissionDate: res[index].DecommissionDate,
            associatedGateway: res[index].GatewayID,
            parameters: res[index].Parameters,
          },
        };
      }
      temp = [...temp, data];
    });
    console.log("all devices temp", res, temp);
    return temp;
  }

  function getdevicescallback(res) {
    console.log("get devices callback345666", res);
    // if (res.status === 201) {
      // const data = alldevices(res.data.devices);
      const data = alldevices(res);
      dispatch(getdeviceno(data));
      setLoading(0);
      setDisableButtons(0);
    // } else if (res.status === 500) {
    //   // pop for error
    // }
  }

  const handleCloseAddForm = () => {
    setOpenForm(0);
    setRequired(0);
    setSaveStatus(0);
    setSelectedtypeIDlib(type[0][0]);
    setSelectedlibList(["none"]);
    setDeviceInfo({
      organizationId: "",
      projectId: "",
      id: "",
      isVirtual: "false",
      data: {
        deviceName: "",
        serialNo: "",
        deviceType: "",
        deviceSubtype: "",
        meterType: meterType[0],
        otherDeviceType: "",
        accuracyClass: "",
        phaseType: phaseType[0],
        finalReading: "",
        deviceCategory: "Feeder",
        make: "",
        model: "",
        firmware: "",
        enable: true,
        description: "",
        commissionDate: "",
        calibrationDate: "",
        decommissionDate: "",
        associatedGateway: "none",
        parameters: {},
      },
    });
    setVirtualOption("false");
    setCloneStatus(0);
  };

    const handleSaveAddForm = () => { 
        // console.log("subscriptionDetails-- ",subscriptionDetails);
        // const counter = subscriptionDetails.filter((val)=>val.FeatureCode==="DeNo") 
        // const counter = handleSubscriptionCountValidation(subscriptionDetails, "DeNo", 1)
        const counter = 1;
        // console.log("counter-- ",counter,(parseInt(counter[0].CurrentLimitCount) + 1 )<= parseInt(counter[0].FeatureLimit), parseInt(counter[0].CurrentLimitCount), parseInt(counter[0].FeatureLimit));
        if(counter){
            console.log("can add device",deviceInfo.data);
            //OG--  if((virtualOption === "false" && deviceInfo.data.deviceName!=="" && deviceInfo.data.serialNo!=="" && deviceInfo.data.make!=="" && deviceInfo.data.model!=="") || (virtualOption === "true" && deviceInfo.data.deviceName !== ""))
            if((deviceInfo.data.deviceName!=="" && deviceInfo.data.serialNo!=="" && deviceInfo.data.make!=="" && deviceInfo.data.model!=="") || (virtualOption === "true" && deviceInfo.data.deviceName !== ""))
            {
                setRequired(0);
                if((deviceno.filter((val,_index)=>val.data.deviceName===deviceInfo.data.deviceName))?.length===0 || deviceInfo.id!==""){
                    if(deviceInfo.data.connectionState===""){
                        deviceInfo.data.connectionState="";
                    }
                    let meterid = '';
                    // let metersubtypeid = '';
                    let ismeter = 0;
                    type[1].map((val,index)=>{
                        if(val==='Meter'){
                            meterid =type[0][index];
                            // metersubtypeid = subtype[0][index][0];
                        }
                    })
                    if(deviceInfo.data.deviceType==="" ){
                        deviceInfo.data.deviceType=type[0][0];
                    }
                    if(deviceInfo.data.deviceSubtype==="" ){
                        deviceInfo.data.deviceSubtype= subtype[0][0][0];
                    }
                    if(deviceInfo.data.deviceType===meterid){
                        ismeter = 1;
                    }else{
                        deviceInfo.data.meterType= meterType[0];
                        deviceInfo.data.phaseType= phaseType[0];
                        deviceInfo.data.finalReading= "";
                    }
                    deviceInfo.organizationId=userdetails.Organizationid;
                    deviceInfo.projectId=projectname;
                    // devicecreate(deviceInfo,deleteTags.tagids,callback);
                    devicecreate(deviceInfo,ismeter,callback);
                    setLoading(1)
                    setDisableButtons(99);
                }
                else{
                    setRequired(2)
                } 
            }
            else{
                setOpenForm(1);
                setRequired(1);
            }
        }else{
            setSubscriptionValid(1);
        }
    };

    function handleSubscriptionCancel(){
        setSubscriptionValid(0);
    }

    // function handleSubscriptionCount(code,action,count){
    //     let list = subscriptionDetails.map(item => ({ ...item }))
    //     let counter = list.findIndex((val)=>val.FeatureCode===code)
    //     console.log("handleSubscriptionCount-- ",list,counter,list[counter]);
    //     if(counter>=0){
    //         if(action==="increment"){
    //             list[counter].CurrentLimitCount = parseInt(list[counter].CurrentLimitCount) + count;
    //         }
    //         else if(action==="decrement"){
    //             list[counter].CurrentLimitCount = parseInt(list[counter].CurrentLimitCount) - count;
    //         }
    //     }
    //     return list;
    // }

  function callback(res) {
    if (res.status === 201) {
      let data;
      // //setdeviceno([...deviceno,deviceInfo]);
      let meterid = "";
      type[1].map((val, index) => {
        if (val === "Meter") {
          meterid = type[0][index];
        }
      });
      if (deviceInfo.data.deviceType === meterid) {
        if (deviceInfo.data.meterType === "Consumer") {
          data = {
            organizationId: deviceInfo.organizationId,
            projectId: deviceInfo.projectId,
            id: deviceInfo.id,
            isVirtual: deviceInfo.isVirtual,
            data: {
              deviceName: deviceInfo.data.deviceName,
              serialNo: deviceInfo.data.serialNo,
              deviceType: deviceInfo.data.deviceType,
              deviceSubtype: deviceInfo.data.deviceSubtype,
              meterType: deviceInfo.data.meterType,
              finalReading: deviceInfo.data.finalReading,
              accuracyClass: deviceInfo.data.accuracyClass,
              phaseType: deviceInfo.data.phaseType,
              deviceCategory: deviceInfo.data.deviceCategory,
              make: deviceInfo.data.make,
              model: deviceInfo.data.model,
              firmware: deviceInfo.data.firmware,
              enable: deviceInfo.data.enable,
              description: deviceInfo.data.description,
              commissionDate: deviceInfo.data.commissionDate,
              calibrationDate: deviceInfo.data.calibrationDate,
              decommissionDate: deviceInfo.data.decommissionDate,
              associatedGateway: deviceInfo.data.associatedGateway,
              parameters: deviceInfo.data.parameters,
            },
          };
        } else {
          data = {
            organizationId: deviceInfo.organizationId,
            projectId: deviceInfo.projectId,
            id: deviceInfo.id,
            isVirtual: deviceInfo.isVirtual,
            data: {
              deviceName: deviceInfo.data.deviceName,
              serialNo: deviceInfo.data.serialNo,
              deviceType: deviceInfo.data.deviceType,
              deviceSubtype: deviceInfo.data.deviceSubtype,
              meterType: deviceInfo.data.meterType,
              finalReading: deviceInfo.data.finalReading,
              deviceCategory: deviceInfo.data.deviceCategory,
              phaseType: deviceInfo.data.phaseType,
              make: deviceInfo.data.make,
              model: deviceInfo.data.model,
              firmware: deviceInfo.data.firmware,
              enable: deviceInfo.data.enable,
              description: deviceInfo.data.description,
              commissionDate: deviceInfo.data.commissionDate,
              calibrationDate: deviceInfo.data.calibrationDate,
              decommissionDate: deviceInfo.data.decommissionDate,
              associatedGateway: deviceInfo.data.associatedGateway,
              parameters: deviceInfo.data.parameters,
            },
          };
        }
      } else {
        data = {
          organizationId: deviceInfo.organizationId,
          projectId: deviceInfo.projectId,
          id: deviceInfo.id,
          isVirtual: deviceInfo.isVirtual,
          data: {
            deviceName: deviceInfo.data.deviceName,
            serialNo: deviceInfo.data.serialNo,
            deviceType: deviceInfo.data.deviceType,
            deviceSubtype: deviceInfo.data.deviceSubtype,
            deviceCategory: deviceInfo.data.deviceCategory,
            make: deviceInfo.data.make,
            model: deviceInfo.data.model,
            firmware: deviceInfo.data.firmware,
            enable: deviceInfo.data.enable,
            description: deviceInfo.data.description,
            commissionDate: deviceInfo.data.commissionDate,
            calibrationDate: deviceInfo.data.calibrationDate,
            decommissionDate: deviceInfo.data.decommissionDate,
            associatedGateway: deviceInfo.data.associatedGateway,
            parameters: deviceInfo.data.parameters,
          },
        };
      }
      if (deviceInfo.id === "") {
        deviceInfo.id = res.data.deviceId;
        deviceInfo.data.parameters = res.data.tags;
        data.data.parameters = deviceInfo.data.parameters;
        data.id = deviceInfo.id;
        dispatch(updatedeviceno(data));
        // setConnState([...connectionState,[deviceInfo.id,"Disconnected",""]])
      } else {
        deviceInfo.data.parameters = res.data.tags;
        data.data.parameters = deviceInfo.data.parameters;
        dispatch(updatedevicedata(data));
        //sjjkk last element as this is in greation
        // deviceno[deviceno.length - 1].data.deviceName=deviceInfo.data.deviceName;
        // deviceno[deviceno.length - 1].data.serialNo=deviceInfo.data.serialNo;
        // deviceno[deviceno.length - 1].data.enable=deviceInfo.data.enable;
        // deviceno[deviceno.length - 1].data.connectionState=deviceInfo.data.enable;
        // deviceno[deviceno.length - 1].data.associatedGateway=deviceInfo.data.associatedGateway;
      }
      setSaveStatus(1);
    } else {
      setSaveStatus(2);
      //
    }
    setLoading(0);
    setDisableButtons(0);
    setSelectLibraryDevice("none");
  }

  function handleDeviceName(selectedValue) {
    console.log("selectedValue7890000000", selectedValue);
    deviceInfo.data.deviceName = selectedValue;
    setDeviceInfo(deviceInfo);
  }

  function handleDeviceSerialNo(selectedValue) {
    deviceInfo.data.serialNo = selectedValue;
    setDeviceInfo(deviceInfo);
  }

  function handleDeviceMake(selectedValue) {
    deviceInfo.data.make = selectedValue;
    setDeviceInfo(deviceInfo);
  }

  function handleDeviceModel(selectedValue) {
    deviceInfo.data.model = selectedValue;
    setDeviceInfo(deviceInfo);
  }

  function handleDeviceFirmware(selectedValue) {
    deviceInfo.data.firmware = selectedValue;
    setDeviceInfo(deviceInfo);
  }

  function handleDeviceDescription(selectedValue) {
    deviceInfo.data.description = selectedValue;
    setDeviceInfo(deviceInfo);
  }

  function handleDeviceType(selectedValue) {
    deviceInfo.data.deviceType = selectedValue;
    setDeviceInfo(deviceInfo);
  }
  function handleDeviceSubtype(selectedValue) {
    deviceInfo.data.deviceSubtype = selectedValue;
    setDeviceInfo(deviceInfo);
  }

  function handleDeviceCategory(selectedValue) {
    deviceInfo.data.deviceCategory = selectedValue.target.value;
    setDeviceInfo(deviceInfo);
  }

  function handleCommissionDate(selectedValue) {
    deviceInfo.data.commissionDate = selectedValue;
    setDeviceInfo(deviceInfo);
  }

  function handleDecommissionDate(selectedValue) {
    deviceInfo.data.decommissionDate = selectedValue;
    setDeviceInfo(deviceInfo);
  }

  function handlePhaseType(selectedValue) {
    deviceInfo.data.phaseType = selectedValue;
    setDeviceInfo(deviceInfo);
  }

  function handleMeterType(selectedValue) {
    deviceInfo.data.meterType = selectedValue;
    setDeviceInfo(deviceInfo);
  }

  function handleFinalReading(selectedValue) {
    deviceInfo.data.finalReading = selectedValue;
    setDeviceInfo(deviceInfo);
  }

  function handleAssociatedGateway(selectedValue) {
    if (selectedValue === "none") {
      deviceInfo.data.associatedGateway = "none";
    } else {
      gatewayidlist.map((value, _index) => {
        if (value.Name === selectedValue) {
          deviceInfo.data.associatedGateway = value.GatewayID;
        }
      });
    }
    setDeviceInfo(deviceInfo);
  }

  function handleDeviceEnable(selectedValue) {
    deviceInfo.data.enable = selectedValue;
    if (selectedValue === false) {
      deviceInfo.data.connectionState = "Disabled";
    }
    setDeviceInfo(deviceInfo);
  }

  function handleConnectionState(selectedValue) {
    deviceInfo.data.connectionState = selectedValue;
    setDeviceInfo(deviceInfo);
  }

  function handleParameter(selectedValue) {
    const temp = Object.values(selectedValue); ///
    deviceInfo.data.parameters = temp;
    setDeviceInfo(deviceInfo);
  }

  function handleDeleteCancel() {
    const len =deleteDeviceArr.length;
    setDeleteDeviceArr([]);
    setDeleteDevice(0);
    if(len>0){
        setDeleteConfirmed(0);   
    }else{
        setDeleteConfirmed(3);
    }
  }

  function handleSelectAllDevices() {
    let ids = [];
    if (ifsearching !== 1) {
      //clear selected all
      if (deviceno.length === deleteDeviceArr.length) {
        setDeleteDeviceArr(ids);
      } else {
        //selects all
        deviceno.map((val) => (ids = [...ids, val.id]));
        setDeleteDeviceArr(ids);
      }
    } else {
      //in case of searched list
      ids = [...deleteDeviceArr];
      //clear selected all
      let searchlistlen = [];
      searchList.map((val) =>
        deleteDeviceArr.map((value) => {
          if (value === val.id) {
            searchlistlen = [...searchlistlen, val.id];
          }
        }),
      );
      if (searchlistlen.length === searchList.length) {
        searchlistlen.map((value) => {
          ids = ids.filter((val) => value !== val);
        });
        //temp.filter((val)=>(val!==props.gatewaylist.id)
        setDeleteDeviceArr(ids);
      } else {
        //selects all
        searchList.map((val) => {
          const ifpresent = ids.filter((value) => value === val.id);
          if (ifpresent.length === 0) {
            ids = [...ids, val.id];
          }
        });
        setDeleteDeviceArr(ids);
      }
    }
  }

  function handleDeleteSelected() {
    // deleteDeviceArr.map((val)=>(
    //     deviceno.filter((value)=>value!==val)
    // ))
    if (deleteDeviceArr.length === 0) {
      setDeleteConfirmed(2);
    } else {
      setDeleteConfirmed(1);
    }
  }

  function handleDeleteConfirmed() {
    // deleteDeviceArr.map((val)=>(
    //     deviceno.filter((value)=>value!==val)
    // ))
    //devicedelete(deleteDeviceArr,userdetails.Organizationid,userdetails.Projectid,deletioncallback)
    if (deleteDeviceArr.length > 0) {
      devicedelete(deleteDeviceArr, deletioncallback);
      setDeleteConfirmed(0);
      setLoading(1);
    } else {
      //popup plz select device
    }
  }

  function deletioncallback(res, _id) {
    if (res.status === 200) {
      const temp = alldevices(res.data.devices);
      dispatch(getdeviceno(temp));
      setDeleteDeviceArr([]);
      setDeleteDevice(0);
      setDeleteSuccess(1);
      setLoading(0);
    } else {
      setDeleteSuccess(2);
      setLoading(0);
    }
  }

  function handleFilterSelected(selectedValue) {
    search.filterSelected = selectedValue;
    setSearch(search);
  }

  function handleSearchText(selectedValue) {
    search.searchText = selectedValue;
    setSearch(search);
  }

  function handleSearchCancel() {
    setSearch({ searchText: "", filterSelected: "" });
    setsearchList([]);
    setifSearching(0);
  }

  function handleSearchClick() {
    let temp = [];
    let templist = [...deviceno];
    if (search.filterSelected !== "") {
      const filterVal = Object.entries(filterMap).find(([_key, value]) =>
        search.filterSelected.includes(value),
      );
      setifSearching(1);
      let val = "";
      //("Enabled" || "Connected")
      if (search.filterSelected.includes("Enabled")) {
        val = true;
      } else if (search.filterSelected.includes("Disabled")) {
        val = false;
      }
      deviceno.filter((value) => {
        if (
          search.filterSelected.includes("Connected") ||
          search.filterSelected.includes("Disconnected")
        ) {
          connState.map((val) => {
            if (val[0] === value.id && search.filterSelected.includes(val[1])) {
              temp = [...temp, value];
            }
          });
        } else {
          Object.keys(value.data).forEach((key) => {
            if (key === filterVal[0]) {
              if (
                value.data[key] === val ||
                value.data[key] === val.toString()
              ) {
                temp = [...temp, value];
              }
            }
          });
        }
        templist = [...temp];
      });
    }
    if (search.searchText !== "") {
      setifSearching(1);
      temp = [];
      templist.filter((value) => {
        if (
          value.id.toLowerCase().includes(search.searchText.toLowerCase()) ||
          value.data.deviceName
            .toLowerCase()
            .includes(search.searchText.toLowerCase()) ||
          value.data.serialNo
            .toLowerCase()
            .includes(search.searchText.toLowerCase()) ||
          value.data.description
            .toLowerCase()
            .includes(search.searchText.toLowerCase()) ||
          value.data.deviceType.includes(search.searchText.toLowerCase()) ||
          value.data.make
            .toLowerCase()
            .includes(search.searchText.toLowerCase()) ||
          value.data.model
            .toLowerCase()
            .includes(search.searchText.toLowerCase()) ||
          value.data.associatedGateway
            .toLowerCase()
            .includes(search.searchText.toLowerCase())
        ) {
          temp = [...temp, value];
        }
      });
    }
    setsearchList(temp);
  }

  const handleCopyData = (event) => {
    navigator.clipboard.writeText(event.currentTarget.value);
    setCopyStatus(1)
  };

  function handleCloneParameter(para) {
    const updatedParameters = para.map((param, i) => ({
      ...param,
      isVirtual: param.isVirtual ? param.isVirtual : "false",
      tagId: "", // Set tagid to an empty string
      key: i.toString(), // Add a unique key for each parameter
    }));
    return updatedParameters;
  }

  function handleClone(event) {
    const temp = deviceno[event.target.id];
    let data;
    let meterid = "";
    type[1].map((val, index) => {
      if (val === "Meter") {
        meterid = type[0][index];
      }
    });
    if (temp.data.deviceType === meterid) {
      if (temp.data.meterType === "Consumer") {
        data = {
          organizationId: temp.organizationId,
          projectId: temp.projectId,
          id: "",
          isVirtual: temp.isVirtual,
          data: {
            deviceName: temp.data.deviceName,
            serialNo: temp.data.serialNo,
            deviceType: temp.data.deviceType,
            deviceSubtype: temp.data.deviceSubtype,
            meterType: temp.data.meterType,
            finalReading: temp.data.finalReading,
            accuracyClass: temp.data.accuracyClass,
            phaseType: temp.data.phaseType,
            deviceCategory: temp.data.deviceCategory,
            make: temp.data.make,
            model: temp.data.model,
            firmware: temp.data.firmware,
            enable: temp.data.enable,
            description: temp.data.description,
            commissionDate: temp.data.commissionDate,
            calibrationDate: temp.data.calibrationDate,
            decommissionDate: temp.data.decommissionDate,
            associatedGateway: temp.data.associatedGateway,
          },
        };
      } else {
        data = {
          organizationId: temp.organizationId,
          projectId: temp.projectId,
          id: "",
          isVirtual: temp.isVirtual,
          data: {
            deviceName: temp.data.deviceName,
            serialNo: temp.data.serialNo,
            deviceType: temp.data.deviceType,
            deviceSubtype: temp.data.deviceSubtype,
            meterType: temp.data.meterType,
            finalReading: temp.data.finalReading,
            deviceCategory: temp.data.deviceCategory,
            phaseType: temp.data.phaseType,
            make: temp.data.make,
            model: temp.data.model,
            firmware: temp.data.firmware,
            enable: temp.data.enable,
            description: temp.data.description,
            commissionDate: temp.data.commissionDate,
            calibrationDate: temp.data.calibrationDate,
            decommissionDate: temp.data.decommissionDate,
            associatedGateway: temp.data.associatedGateway,
          },
        };
      }
    } else if (temp.data.deviceType === "Other") {
      data = {
        organizationId: temp.organizationId,
        projectId: temp.projectId,
        id: "",
        isVirtual: temp.isVirtual,
        data: {
          deviceName: temp.data.deviceName,
          serialNo: temp.data.serialNo,
          deviceType: temp.data.deviceType,
          deviceSubtype: temp.data.deviceSubtype,
          deviceCategory: temp.data.deviceCategory,
          make: temp.data.make,
          model: temp.data.model,
          firmware: temp.data.firmware,
          enable: temp.data.enable,
          description: temp.data.description,
          commissionDate: temp.data.commissionDate,
          calibrationDate: temp.data.calibrationDate,
          decommissionDate: temp.data.decommissionDate,
          associatedGateway: temp.data.associatedGateway,
        },
      };
    } else {
      data = {
        organizationId: temp.organizationId,
        projectId: temp.projectId,
        id: "",
        isVirtual: temp.isVirtual,
        data: {
          deviceName: temp.data.deviceName,
          serialNo: temp.data.serialNo,
          deviceType: temp.data.deviceType,
          deviceSubtype: temp.data.deviceSubtype,
          deviceCategory: temp.data.deviceCategory,
          make: temp.data.make,
          model: temp.data.model,
          firmware: temp.data.firmware,
          enable: temp.data.enable,
          description: temp.data.description,
          commissionDate: temp.data.commissionDate,
          calibrationDate: temp.data.calibrationDate,
          decommissionDate: temp.data.decommissionDate,
          associatedGateway: temp.data.associatedGateway,
        },
      };
    }
    data.data.deviceName = data.data.deviceName + "_clone";
    data.data.parameters = temp.data.parameters
      ? handleCloneParameter(temp.data.parameters)
      : [];
    setDeviceInfo(data);
    setOpenForm(true);
    setVirtualOption(temp.isVirtual);
    setCloneStatus(1);
  }

  function handleRefresh() {
    getDeviceTypesList(getDeviceTypesListcallback);
    // getdevices(getdevicescallback);
    getgatewaylist(getgatewaylistcallback);
    getDeviceLibraryList(getDeviceLibraryListcallback);
    setLoading(1);
    setDisableButtons(99);
  }

  function handleToastClose() {
    setSaveStatus(0);
  }

  function handleDeleteToastClose() {
    setDeleteSuccess(0);
  }

  useEffect(() => {
    deviceconnetionStatus(devicestatuscallback);
  }, [deviceno]);

  function devicestatuscallback(res) {
    setConnState(res.data);
  }

  function handleConnectionStatus(id) {
    let status = false;
    connState.map((val) => {
      if (val[0] === id && val[1] === "Connected") {
        status = true;
      }
    });
    return status;
  }

  const DeviceCard = (props) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    let gateway = "none";
    gatewayidlist.map((value, _index) => {
      if (value.GatewayID === props.devicelist.data.associatedGateway) {
        gateway = value.Name;
      }
    });

    const handleDeviceCardMore = (event) => {
      setAnchorEl(event.currentTarget);
    };

    const handleCloseMenu = () => {
      setAnchorEl(null);
    };

    const handleDeviceEdit = () => {
      const temp = props.devicelist;
      let data;
      let meterid = "";
      type[1].map((val, index) => {
        if (val === "Meter") {
          meterid = type[0][index];
        }
      });
      if (temp.data.deviceType === meterid) {
        if (temp.data.meterType === "Consumer") {
          data = {
            organizationId: temp.organizationId,
            projectId: temp.projectId,
            id: temp.id,
            isVirtual: temp.isVirtual,
            data: {
              deviceName: temp.data.deviceName,
              serialNo: temp.data.serialNo,
              deviceType: temp.data.deviceType,
              deviceSubtype: temp.data.deviceSubtype,
              meterType: temp.data.meterType,
              finalReading: temp.data.finalReading,
              accuracyClass: temp.data.accuracyClass,
              phaseType: temp.data.phaseType,
              deviceCategory: temp.data.deviceCategory,
              make: temp.data.make,
              model: temp.data.model,
              firmware: temp.data.firmware,
              enable: temp.data.enable,
              description: temp.data.description,
              commissionDate: temp.data.commissionDate,
              calibrationDate: temp.data.calibrationDate,
              decommissionDate: temp.data.decommissionDate,
              associatedGateway: temp.data.associatedGateway,
              parameters: temp.data.parameters,
            },
          };
        } else {
          data = {
            organizationId: temp.organizationId,
            projectId: temp.projectId,
            id: temp.id,
            isVirtual: temp.isVirtual,
            data: {
              deviceName: temp.data.deviceName,
              serialNo: temp.data.serialNo,
              deviceType: temp.data.deviceType,
              deviceSubtype: temp.data.deviceSubtype,
              meterType: temp.data.meterType,
              finalReading: temp.data.finalReading,
              deviceCategory: temp.data.deviceCategory,
              phaseType: temp.data.phaseType,
              make: temp.data.make,
              model: temp.data.model,
              firmware: temp.data.firmware,
              enable: temp.data.enable,
              description: temp.data.description,
              commissionDate: temp.data.commissionDate,
              calibrationDate: temp.data.calibrationDate,
              decommissionDate: temp.data.decommissionDate,
              associatedGateway: temp.data.associatedGateway,
              parameters: temp.data.parameters,
            },
          };
        }
      } else if (temp.data.deviceType === "Other") {
        data = {
          organizationId: temp.organizationId,
          projectId: temp.projectId,
          id: temp.id,
          isVirtual: temp.isVirtual,
          data: {
            deviceName: temp.data.deviceName,
            serialNo: temp.data.serialNo,
            deviceType: temp.data.deviceType,
            deviceSubtype: temp.data.deviceSubtype,
            deviceCategory: temp.data.deviceCategory,
            make: temp.data.make,
            model: temp.data.model,
            firmware: temp.data.firmware,
            enable: temp.data.enable,
            description: temp.data.description,
            commissionDate: temp.data.commissionDate,
            calibrationDate: temp.data.calibrationDate,
            decommissionDate: temp.data.decommissionDate,
            associatedGateway: temp.data.associatedGateway,
            parameters: temp.data.parameters,
          },
        };
      } else {
        data = {
          organizationId: temp.organizationId,
          projectId: temp.projectId,
          id: temp.id,
          isVirtual: temp.isVirtual,
          data: {
            deviceName: temp.data.deviceName,
            serialNo: temp.data.serialNo,
            deviceType: temp.data.deviceType,
            deviceSubtype: temp.data.deviceSubtype,
            deviceCategory: temp.data.deviceCategory,
            make: temp.data.make,
            model: temp.data.model,
            firmware: temp.data.firmware,
            enable: temp.data.enable,
            description: temp.data.description,
            commissionDate: temp.data.commissionDate,
            calibrationDate: temp.data.calibrationDate,
            decommissionDate: temp.data.decommissionDate,
            associatedGateway: temp.data.associatedGateway,
            parameters: temp.data.parameters,
          },
        };
      }
      setDeviceInfo(data);
      setOpenForm(1);
      console.log("editdeviceinfo", temp, props.devicelist);
      setVirtualOption(temp.isVirtual);
    };

    function handleDeleteCheck(selected) {
      const temp = [...deleteDeviceArr];
      if (selected === true) {
        temp.push(props.devicelist.id);
        setDeleteDeviceArr(temp);
        //temp=[...temp,props.index]
      } else {
        setDeleteDeviceArr(temp.filter((val) => val !== props.devicelist.id));
      }
    }

    useEffect(() => {
      if (deleteDevice === 2) {
      }
    }, [deleteDevice]);

    return (
      <Box
        key={props.index}
        sx={{
          display: "flex",
          flexDirection: "row",
          height: "125px",
          width: "calc(25% - 6px)",
          minWidth: "300px" /*394.5px */,
          textAlign: "left",
          boxSizing: "border-box",
          overflowWrap: "break-word",
        }}
      >
        <Box
          sx={{
            height: "100%",
            width: "1.6%",
            background: (
              typeof props.devicelist.data.enable == "string"
                ? props.devicelist.data.enable === "true"
                  ? true
                  : false
                : props.devicelist.data.enable
            )
              ? handleConnectionStatus(props.devicelist.id, connState) === true
                ? "var(--GreenBaseColor)"
                : "var(--RedBaseColor)"
              : "var(--GreyBaseColor)",
          }}
        ></Box>
        <Box
          key={props.index}
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
            width: "98.4%",
            background: "var(--SecondaryBackground)",
            padding: "10px 10px 10px 10px",
            textAlign: "left",
            boxSizing: "border-box",
            overflowWrap: "break-word",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              width: "100%",
              gap: "4px",
            }}
          >
            {/* {deleteDevice===true? */}
            <Box sx={{ marginTop: "-2.58px", marginRight: "4px" }}>
              <CustomCheckbox
                style={{ Padding: 0 }}
                defaultChecked={
                  deleteDeviceArr.includes(props.devicelist.id) === true
                    ? true
                    : false
                }
                onChange={handleDeleteCheck}
                width={15}
                height={15}
              />
            </Box>
            {/* :
                            <></>
                        } */}
            <CustomTooltip title={props.devicelist.data.deviceName} ifOverflow={true} offset={[30,-20]} placement={'right-end'}>
            <Typography
              sx={{
                fontFamily: "Roboto",
                fontSize: "20px",
                fontWeight: "700",
                color: "var(--PrimaryText)",
                marginTop: "-4px",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                overflow: "hidden",
              }}
            >
              {props.devicelist.data.deviceName}
            </Typography>
            </CustomTooltip>
            <Box style={{ flexGrow: 1 }}></Box>
            <Button
              id="basic-button"
              aria-controls={open ? "basic-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
              onClick={handleDeviceCardMore}
              disabled={disableButtons !== 0 ? true : false}
              style={{
                postion: "inline",
                height: "19px",
                maxWidth: "16px",
                minWidth: "16px",
                fontSize: "12px",
                fontWeight: "700",
                color:
                  disableButtons !== 0
                    ? theme === "light"
                      ? "#C1C1C1"
                      : "#3C3C3C"
                    : "var(--PrimaryText)",
                textTransform: "none",
                padding: 0,
                margin: 0,
              }}
            >
              <MoreVertIcon sx={{ height: "20px", width: "20px" }} />
            </Button>
            <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={open}
              onClose={handleCloseMenu}
              MenuListProps={{
                "aria-labelledby": "basic-button",
              }}
              PaperProps={{
                component: "form",
                sx: {
                  borderRadius: 0,
                  bgcolor: theme === "dark" ? "#000000" : "#FFFFFF",
                  maxHeight: "150px",
                  maxWidth: "150px",
                  width: "120px",
                  height: "89px",
                  overflow: "auto",
                  color: theme === "dark" ? "#C1C1C1" : "#7E7E7E",
                  padding: "0px 0px 0px 0px",
                },
              }}
              style={{
                "::-webkit-scrollbar-track": {
                  background: "#000000",
                },
              }}
              sx={{
                "&.MuiList-root MuiList-padding MuiMenu-list": {
                  padding: "0px 0px 0px 0px",
                },
              }}
            >
              <MenuItem onClick={handleDeviceEdit} id={props.index}>
                Edit
              </MenuItem>
              {/* <Divider variant="middle" style={{margin:"0px 2px 0px 2px", background:theme==='dark'?'#3C3C3C':'#EFEFEF'}}/>
                            <MenuItem onClick={handleDeviceDelete} id={props.index}>Delete</MenuItem> */}
              <Divider
                variant="middle"
                style={{
                  margin: "0px 2px 0px 2px",
                  background: theme === "dark" ? "#3C3C3C" : "#EFEFEF",
                }}
              />
              <MenuItem onClick={handleClone} id={props.index}>
                Clone Device
              </MenuItem>
              {/* <Divider variant="middle" style={{margin:"0px 2px 0px 2px", background:theme==='dark'?'#3C3C3C':'#EFEFEF'}}/>
                            <MenuItem onClick={()=>setOpen1(true)}  id={props.index}>dailog</MenuItem> */}
              {/* <MenuItem onClick={() =>  navigator.clipboard.writeText(props.devicelist.data.primaryConnectionString)}  id={props.index}>Copy String</MenuItem> */}
            </Menu>
            {/* <CustomDialogBox dialogTitle={"hi"} dialogText={"hi"} openDialog={open1} handleCloseDialog={()=>setOpen1(false)} handleConfirmDialog={()=>setOpen1(false)} confirmText={"hi"} cancelText={"hi"}/> */}
            {/* <DeviceForm /*formType={"Edit"} index={props.index} openForm={openEditForm}* closeForm={handleCloseEditForm} saveForm={handleSaveEditForm} deviceData={deviceData}/> */}
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              width: "calc(100% - 8px)",
              fontFamily: "Roboto",
              margin: "0px 0px 0px 0px",
              boxSizing: "border-box",
              gap: "16px",
            }}
          >
            <CustomTooltip title={props.devicelist.id} inputTitle={`Device ID: ${props.devicelist.id}`} ifOverflow={true} offset={[30,-20]} placement={'right-end'}>
            <Typography
              className="config-heading"
              style={{
                fontSize: "16px",
                fontWeight: 400,
                color: "var(--PrimaryText)",
                lineHeight: "28px",
                width: "50%",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                overflow: "hidden",
              }}
            >
              Device ID: {props.devicelist.id}
            </Typography>
            </CustomTooltip>
            <CustomTooltip title={props.devicelist.data.serialNo} inputTitle={`Serial no: ${props.devicelist.data.serialNo}`} ifOverflow={true} offset={[30,-20]} placement={'right-end'}>
            <Typography
              className="config-heading"
              style={{
                fontSize: "16px",
                fontWeight: 400,
                color: "var(--PrimaryText)",
                lineHeight: "28px",
                width: "50%",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                overflow: "hidden",
              }}
            >
              Serial no: {props.devicelist.data.serialNo}
            </Typography>
            </CustomTooltip>
          </Box>
          <Typography
            className="config-heading"
            style={{
              fontSize: "16px",
              fontWeight: 700,
              color: "var(--PrimaryText)",
              marginRight: "24px",
              marginTop: "8px",
            }}
          >
            Associated Gateway
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              width: "100%",
              fontSize: "16px",
              fontFamily: "Roboto",
              margin: "0px 0px 12px 0px",
              flexWrap: "wrap",
            }}
          >
            {/* <Box sx={{display:'flex', flexDirection:'row',width:'50%'}}>
                            <Typography className="config-heading" style={{ fontSize: '16px', fontWeight: 400, color: "var(--GreyVariation_4)", marginRight:"12px" }}>Total</Typography>
                            <Typography className="config-heading" style={{ fontSize: '16px', fontWeight: 400, color: "var(--PrimaryText)", marginRight:"20px" }}>00</Typography>
                        </Box>
                        <Box sx={{display:'flex', flexDirection:'row',width:'50%'}}>
                            <Typography className="config-heading" style={{ fontSize: '16px', fontWeight: 400, color: "var(--GreyVariation_4)", marginRight:"12px" }}>Enabled</Typography>
                            <Typography className="config-heading" style={{ fontSize: '16px', fontWeight: 400, color: "var(--GreyVariation_3)", marginRight:"20px" }}>00</Typography>
                        </Box>
                        <Box sx={{display:'flex', flexDirection:'row',width:'50%'}}>
                            <Typography className="config-heading" style={{ fontSize: '16px', fontWeight: 400, color: "var(--GreyVariation_4)", marginRight:"12px" }}>Connected</Typography>
                            <Typography className="config-heading" style={{ fontSize: '16px', fontWeight: 400, color: "var(--GreenBaseColor)", marginRight:"20px" }}>00</Typography>
                        </Box>
                        <Box sx={{display:'flex', flexDirection:'row',width:'50%'}}>
                            <Typography className="config-heading" style={{ fontSize: '16px', fontWeight: 400, color: "var(--GreyVariation_4)", marginRight:"12px" }}>Disconnected</Typography>
                            <Typography className="config-heading" style={{ fontSize: '16px', fontWeight: 400, color: "var(--RedBaseColor)", marginRight:"20px" }}>00</Typography>
                        </Box> */}
            <CustomTooltip title={props.devicelist.data.associatedGateway !== "none"? gateway: "Not Associated"} ifOverflow={true} offset={[30,-20]} placement={'right-end'}>
            <Typography
              className="config-heading"
              style={{
                fontSize: "16px",
                fontWeight: 400,
                color: "var(--PrimaryText)",
                marginRight: "20px",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                overflow: "hidden",
              }}
            >
              {props.devicelist.data.associatedGateway !== "none"
                ? gateway
                : "Not Associated"}
            </Typography>
            </CustomTooltip>
            {/* <Typography className="config-heading" style={{ fontSize: '16px', fontWeight: 400, color: "var(--GreyVariation_3)", marginRight:"20px" }}>00</Typography>
                         <Typography className="config-heading" style={{ fontSize: '16px', fontWeight: 400, color: "var(--GreenBaseColor)", marginRight:"20px" }}>00</Typography>
                         <Typography className="config-heading" style={{ fontSize: '16px', fontWeight: 400, color: "var(--RedBaseColor)", marginRight:"20px" }}>00</Typography> */}
          </Box>
          {/* <Typography className="config-heading" style={{ fontSize: '16px', fontWeight: 700, color: "var(--PrimaryText)" }}>Device Details</Typography>
                    <Box  sx={{display:'flex', flexDirection:'row',width:'calc(100% - 8px)',fontFamily:"Roboto",margin:"2px 0px 12px 0px",boxSizing:'border-box',gap:"16px"}}>
                        <Typography className="config-heading" style={{ fontSize: '16px', fontWeight: 400, color: "var(--PrimaryText)",lineHeight:"28px" ,width:"50%",whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Device ID: {props.devicelist.id}</Typography>
                        <Typography className="config-heading" style={{ fontSize: '16px', fontWeight: 400, color: "var(--PrimaryText)",lineHeight:"28px" ,width:"50%",whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Serial no: {props.devicelist.data.serialNo}</Typography>
                    </Box> */}
        </Box>
      </Box>
    );
  };

  const DeviceForm = (props) => {
    const [typeIndex, setTypeIndex] = React.useState(0);
    const [deviceDetails, setDeviceDetails] = React.useState(1);
    const [associatedGatewayDetails, setAssociatedGatewayDetails] =
      React.useState(1);
    const [parameterDetails, setParameterDetails] = React.useState(0);
    const [connectionDetails, setConnectionDetails] = React.useState(1);
    const [meter, setMeter] = React.useState(type[1][0] === "Meter" ? 1 : 0);
    let gateway = "none";
    gatewayidlist.map((value) => {
      if (value.GatewayID === deviceInfo.data.associatedGateway) {
        gateway = value.Name;
      }
    });

    const deviceCreationOptions = [["Use Library", "Library"]];

    const [creationOption, setCreationOption] = React.useState(
      deviceCreationOptions[0][1],
    );

    useEffect(() => {
      type[0].map((val, index) => {
        if (val === props.deviceData.data.deviceType) {
          setTypeIndex(index);
          // typeName = type[1][index]
          if (type[1][index] === "Meter") {
            setMeter(1);
          } else {
            setMeter(0);
          }
        }
      });
    }, [props.deviceData]);

    function handleDeviceTypeF(selectedValue) {
      type[1].map((val, index) => {
        if (val === selectedValue) {
          setTypeIndex(index);
          handleDeviceType(type[0][index]);
        }
      });
      if (selectedValue === "Meter") {
        setMeter(1);
      } else {
        setMeter(0);
      }
    }

    function handleDeviceSubtypeF(selectedValue) {
      subtype[1][typeIndex].map((val, index) => {
        if (val === selectedValue) {
          handleDeviceSubtype(subtype[0][typeIndex][index]);
        }
      });
    }

    function handleDeleteTagsF(selected) {
      // deleteTags.tagids=[...selected];
      const temp = Object.values(selected);
      let id = -1;
      deviceno.map((val, index) => {
        if (val.id === deviceInfo.id) {
          id = index;
        }
      });
      if (id !== -1) {
        let data = { ...deviceno[id], data: { ...deviceno[id].data } };
        data.data.parameters = temp;
        dispatch(updatedevicedata(data));
      }
      setDeleteSuccess(1);
      // setDeleteTags(deleteTags);
    }

    function handletypename(deviceType) {
      let typeName = "";
      if (deviceType === "") {
        typeName = "none";
      } else {
        type[0].map((val, index) => {
          if (val === deviceType) {
            // setTypeIndex(index);
            typeName = type[1][index];
          }
        });
      }
      return typeName;
    }

    function handlesubtypename(deviceSubtype) {
      let subtypeName = subtype[1][typeIndex][0];
      subtype[0][typeIndex].map((val, index) => {
        // val.map((v,i)=>{
        if (val === deviceSubtype) {
          subtypeName = subtype[1][typeIndex][index];
        }
        // })
      });
      return subtypeName;
    }

    function handleCreationOption(selectedValue) {
      setCreationOption(selectedValue.target.value);
    }

    function handleVirtualDeviceOption(selectedValue) {
      setVirtualOption(selectedValue.target.value);
      deviceInfo.isVirtual = selectedValue.target.value;
      setDeviceInfo({ ...deviceInfo });
    }

    function handleDeviceLibrary(selectedValue) {
      setSelectLibraryDevice(selectedValue);
      if (selectedValue === "none") {
        let data = {
          organizationId: "",
          projectId: "",
          id: "",
          isVirtual: "false",
          data: {
            deviceName: "",
            serialNo: "",
            deviceType: "",
            deviceSubtype: "",
            meterType: meterType[0],
            otherDeviceType: "",
            accuracyClass: "",
            phaseType: phaseType[0],
            finalReading: "",
            deviceCategory: "Feeder",
            make: "",
            model: "",
            firmware: "",
            enable: true,
            description: "",
            commissionDate: "",
            calibrationDate: "",
            decommissionDate: "",
            associatedGateway: "none",
            parameters: {},
          },
        };
        setDeviceInfo(data);
      } else {
        // setDeviceLibrary(selectedValue.target.value);
        let id = deviceLibraryList.find(
          (item) =>
            (item[1].charAt(0) === "_" ? item[1].substring(1) : item[1]) ===
            selectedValue,
        );

        let ifstd = "0";
        if (id[1].charAt(0) === "_") {
          ifstd = "1";
        }
        getDeviceLibraryByIdList(
          id[0],
          ifstd,
          getDeviceLibraryByIdListcallback,
        );
        setLoading(1);
        setDisableButtons(99);
      }
    }

    function getDeviceLibraryByIdListcallback(res) {
      if (res.status === 200) {
        const device = alldevices(res.data.devices);
        let temp = device[0];
        let data;
        let meterid = "";
        type[1].map((val, index) => {
          if (val === "Meter") {
            meterid = type[0][index];
          }
        });
        if (temp.data.deviceType === meterid) {
          if (temp.data.meterType === "Consumer") {
            data = {
              organizationId: temp.organizationId,
              projectId: temp.projectId,
              id: "",
              isVirtual: "false",
              data: {
                deviceName: temp.data.deviceName,
                serialNo: "",
                deviceType: temp.data.deviceType,
                deviceSubtype: temp.data.deviceSubtype,
                meterType: temp.data.meterType,
                finalReading: temp.data.finalReading,
                accuracyClass: temp.data.accuracyClass,
                phaseType: temp.data.phaseType,
                deviceCategory: temp.data.deviceCategory,
                make: temp.data.make,
                model: temp.data.model,
                firmware: temp.data.firmware,
                enable: temp.data.enable,
                description: temp.data.description,
                commissionDate: "",
                calibrationDate: "",
                decommissionDate: "",
                associatedGateway: "none",
              },
            };
          } else {
            data = {
              organizationId: temp.organizationId,
              projectId: temp.projectId,
              id: "",
              isVirtual: "false",
              data: {
                deviceName: temp.data.deviceName,
                serialNo: "",
                deviceType: temp.data.deviceType,
                deviceSubtype: temp.data.deviceSubtype,
                meterType: temp.data.meterType,
                finalReading: temp.data.finalReading,
                deviceCategory: temp.data.deviceCategory,
                phaseType: temp.data.phaseType,
                make: temp.data.make,
                model: temp.data.model,
                firmware: temp.data.firmware,
                enable: temp.data.enable,
                description: temp.data.description,
                commissionDate: "",
                calibrationDate: "",
                decommissionDate: "",
                associatedGateway: "none",
              },
            };
          }
        } else if (temp.data.deviceType === "Other") {
          data = {
            organizationId: temp.organizationId,
            projectId: temp.projectId,
            id: "",
            isVirtual: "false",
            data: {
              deviceName: temp.data.deviceName,
              serialNo: "",
              deviceType: temp.data.deviceType,
              deviceSubtype: temp.data.deviceSubtype,
              deviceCategory: temp.data.deviceCategory,
              make: temp.data.make,
              model: temp.data.model,
              firmware: temp.data.firmware,
              enable: temp.data.enable,
              description: temp.data.description,
              commissionDate: "",
              calibrationDate: "",
              decommissionDate: "",
              associatedGateway: "none",
            },
          };
        } else {
          data = {
            organizationId: temp.organizationId,
            projectId: temp.projectId,
            id: "",
            isVirtual: "false",
            data: {
              deviceName: temp.data.deviceName,
              serialNo: "",
              deviceType: temp.data.deviceType,
              deviceSubtype: temp.data.deviceSubtype,
              deviceCategory: temp.data.deviceCategory,
              make: temp.data.make,
              model: temp.data.model,
              firmware: temp.data.firmware,
              enable: temp.data.enable,
              description: temp.data.description,
              commissionDate: "",
              calibrationDate: "",
              decommissionDate: "",
              associatedGateway: "none",
            },
          };
        }
        data.data.deviceName =
          data.data.deviceName.charAt(0) === "_"
            ? data.data.deviceName.substring(1)
            : data.data.deviceName;
        data.data.parameters = temp.data.parameters
          ? handleCloneParameter(temp.data.parameters)
          : [];
        setDeviceInfo(data);
      } else {
        //need to include error handling message
      }
      setLoading(0);
      setDisableButtons(0);
    }

    function handleDeviceTypeForLib(selected) {
      let temp = ["none"];
      let selectedType = "";
      selectedType = type[0][type[1].indexOf(selected)];
      temp = [
        ...temp,
        ...deviceLibraryList
          .filter((val) => val[2] === selectedType)
          .map((val) =>
            val[1].charAt(0) === "_" ? val[1].substring(1) : val[1],
          ),
      ];
      setSelectedtypeIDlib(selectedType);
      setSelectedlibList(temp);
      setSelectLibraryDevice("none");
      let data = {
        organizationId: "",
        projectId: "",
        id: "",
        isVirtual: "false",
        data: {
          deviceName: "",
          serialNo: "",
          deviceType: "",
          deviceSubtype: "",
          meterType: meterType[0],
          otherDeviceType: "",
          accuracyClass: "",
          phaseType: phaseType[0],
          finalReading: "",
          deviceCategory: "Feeder",
          make: "",
          model: "",
          firmware: "",
          enable: true,
          description: "",
          commissionDate: "",
          calibrationDate: "",
          decommissionDate: "",
          associatedGateway: "none",
          parameters: {},
        },
      };
      setDeviceInfo(data);
    }

    return (
      <Box sx={{ width: "100%", height: "100%" }}>
        <Box
          sx={{
            width: "100%",
            height:
              props.deviceData.id === ""
                ? cloneStatus === 0
                  ? "21%"
                  : "14%"
                : "7%",
            display: "flex",
            flexDirection: "column",
            alignItems: "left",
            gap: "8px",
          }}
        >
          <Typography
            style={{
              fontSize: "24px",
              alignSelf: "flex-start",
              fontWeight: 700,
              color: "#008CD7",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              overflow: "hidden",
            }}
          >
            {props.deviceData.id !== ""
              ? props.deviceData.data.deviceName
              : "Devices"}
          </Typography>
          {/* <Box sx={{flexGrow:1}}></Box>
                    {required===1?<><Typography sx={{color:"#DC272D"}}>required fields to must be filled</Typography></>:<></>}
                    {saveStatus!==0?
                        <>
                            <Typography sx={{color: saveStatus===1? theme==='dark'?'#C1C1C1':'#3C3C3C':"#DC272D"}}>{saveStatus===1?"Saved Successfully!":"Save Failed"}</Typography>
                        </>
                        :
                        <></>
                    }
                    <CustomCancelButton onClick={props.closeForm} children={'Cancel'}></CustomCancelButton>
                    {/* <Button id={props.index} onClick={props.saveForm}>Save</Button> *}
                    <CustomButton id={props.index} onClick={props.saveForm} children={'Save'} width={'12px'} /> */}
          {props.deviceData.id === "" ? (
            <>
              {cloneStatus === 0 ? (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    marginLeft: "0px",
                  }}
                >
                  <Typography
                    style={{
                      fontSize: "16px",
                      fontWeight: 400,
                      color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
                      width: "217px",
                      textAlign: "left",
                    }}
                  >
                    Device Creation
                  </Typography>
                  <CustomRadioButton
                    row={true}
                    onChange={handleVirtualDeviceOption}
                    options={virtualDeviceOptions}
                    fontSize={16}
                    width={"100%"}
                    optionWidth={157}
                    defaultValue={virtualOption}
                  />
                </Box>
              ) : (
                <></>
              )}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  marginLeft: "0px",
                }}
              >
                <CustomRadioButton
                  row={true}
                  onChange={handleCreationOption}
                  options={deviceCreationOptions}
                  fontSize={16}
                  width={"100%"}
                  optionWidth={141}
                  defaultValue={creationOption}
                />
                {/* <CustomDropDown options={deviceLibraryList[1]} onChange={handleDeviceLibrary} disabled={creationOption!=="Library"?true:false} defaultValue={selectLibraryDevice}></CustomDropDown> */}
                <Typography
                  style={{
                    fontSize: "16px",
                    fontWeight: 400,
                    color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
                    width: "224px",
                  }}
                >
                  Device Type
                </Typography>
                <CustomDropDown
                  options={[...type[1]]}
                  onChange={handleDeviceTypeForLib}
                  /*disabled={props.deviceData.id!==""?true:false}*/ defaultValue={handletypename(
                    selectedtypeIDlib,
                  )}
                ></CustomDropDown>
                <Typography
                  style={{
                    fontSize: "16px",
                    fontWeight: 400,
                    color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
                    width: "224px",
                  }}
                >
                  Device
                </Typography>
                <CustomDropDown
                  options={selectedlibList}
                  onChange={handleDeviceLibrary}
                  /*disabled={props.deviceData.id!==""?true:false}*/ defaultValue={
                    selectLibraryDevice
                  }
                ></CustomDropDown>
              </Box>
            </>
          ) : (
            <></>
          )}
        </Box>
        <Box
          sx={{
            width: "100%",
            height: props.deviceData.id === "" ? "79%" : "93%",
            overflow: "auto",
          }}
        >
          <Typography
            className="config-heading"
            style={{
              fontSize: "20px",
              fontWeight: 400,
              color: "#008CD7",
              padding: "4px",
              marginTop:
                "20px" /*backgroundColor:theme==='dark'?'#3C3C3C40':'#FFFFFF80'*/,
            }}
          >
            Device Details{" "}
            <Button
              onClick={() => {
                deviceDetails === 1 ? setDeviceDetails(0) : setDeviceDetails(1);
              }}
            >
              {deviceDetails === 1 ? (
                <ExpandLessOutlinedIcon
                  style={{
                    width: "28px",
                    height: "28px",
                    fontWeight: 700,
                    color: "#008CD7",
                  }}
                />
              ) : (
                <ExpandMoreOutlinedIcon
                  style={{
                    width: "28px",
                    height: "28px",
                    fontWeight: 700,
                    color: "#008CD7",
                  }}
                />
              )}
            </Button>
          </Typography>
          {deviceDetails === 1 ? (
            <Box
              style={{ overflow: "auto" }}
              sx={{
                display: "flex",
                gap: "0px",
                flexWrap: "wrap",
                padding: "4px 4px 12px 4px",
                backgroundColor: theme === "dark" ? "#3C3C3C40" : "#FFFFFF80",
              }}
            >
              <Box
                className="config-form-box"
                sx={{
                  padding: "4px 4px 4px 0px",
                  width: "33.33%",
                  boxSizing: "border-box",
                  marginTop: "12px",
                }}
              >
                <Typography
                  style={{
                    fontSize: "16px",
                    fontWeight: 400,
                    color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
                    width: "224px",
                  }}
                >
                  Device Name
                  <span style={{ color: "red", marginLeft: "5px" }}>*</span>
                </Typography>
                <CustomTextField
                  prefix={virtualOption === "true" ? "vd-" : ""}
                  id={"negative-feedback"}
                  onChange={handleDeviceName}
                  disabled={props.deviceData.id !== "" ? true : false}
                  defaultValue={
                    props.deviceData.id !== ""
                      ? props.deviceData.data.deviceName
                      : deviceInfo.data.deviceName
                  }
                  maxLength={250}
                  width={224}
                  permittedCharacters={"^[a-zA-Z][a-zA-Z0-9_]*$"}
                  errorText={"Only alphanumeric and '_' characters are allowed"}
                />
              </Box>
              <Box
                className="config-form-box"
                sx={{
                  padding: "4px 4px 4px 0px",
                  width: "33.33%",
                  boxSizing: "border-box",
                  marginTop: "12px",
                }}
              >
                <Typography
                  style={{
                    fontSize: "16px",
                    fontWeight: 400,
                    color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
                    width: "224px",
                  }}
                >
                  Device Serial No.
                  <span style={{ color: "red", marginLeft: "5px" }}>
                    {virtualOption === "true" ? "" : "*"}
                  </span>
                </Typography>
                <CustomTextField
                  id={"negative-feedback"}
                  onChange={handleDeviceSerialNo}
                  /*disabled={props.deviceData.id!==""?true:false}*/ defaultValue={
                    props.deviceData.id !== ""
                      ? props.deviceData.data.serialNo
                      : deviceInfo.data.serialNo
                  }
                  maxLength={32}
                  width={224}
                  permittedCharacters={"^[a-zA-Z0-9][a-zA-Z0-9_]*$"}
                  errorText={"Only alphanumeric and '_' characters are allowed"}
                />
              </Box>
              {props.deviceData.id !== "" ? (
                <>
                  <Box
                    className="config-form-box"
                    sx={{
                      padding: "4px 4px 4px 0px",
                      width: "33.33%",
                      boxSizing: "border-box",
                      marginTop: "12px",
                    }}
                  >
                    <Typography
                      style={{
                        fontSize: "16px",
                        fontWeight: 400,
                        color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
                        width: "224px",
                      }}
                    >
                      Device ID
                    </Typography>
                    {/* <Box className="config-form-box"style={{gap:0 ,marginTop:0,width:'calc(100% - 354px)',overflowWrap:"break-word"}} > */}
                    <Typography
                      style={{
                        fontSize: "16px",
                        fontWeight: 400,
                        color:
                          theme === "dark"
                            ? "#C1C1C1"
                            : "#3C3C3C" /*width:"224px"*/,
                      }}
                    >
                      {props.deviceData.id}
                    </Typography>
                    {/* </Box> */}
                     <CustomTooltip title={'Copy'} offset={[30,-20]} placement={'right-end'}>
                    <Button
                      onClick={handleCopyData}
                      value={props.deviceData.id}
                      style={{
                        fontSize: "12px",
                        height: "32px",
                        padding: "0px",
                        width: "32px",
                        minWidth: "30px",
                        fontWeight: 400,
                        color: "#7E7E7E",
                        alignSelf: "center",
                        marginLeft: "0px",
                        marginRight: "auto",
                        marginTop: "-4px",
                      }}
                    >
                      <LK_Copy
                        color="var(--GreyBaseColor)"
                        width={"24px"}
                        height={"24px"}
                      />
                    </Button>
                    </CustomTooltip>
                  </Box>
                </>
              ) : (
                <>
                  <Box
                    className="config-form-box"
                    sx={{
                      padding: "4px 4px 4px 0px",
                      width: "33.33%",
                      boxSizing: "border-box",
                      marginTop: "12px",
                    }}
                  ></Box>
                </>
              )}
              <Box
                className="config-form-box"
                sx={{
                  padding: "4px 4px 4px 0px",
                  width: "33.33%",
                  boxSizing: "border-box",
                  marginTop: "12px",
                }}
              >
                <Typography
                  style={{
                    fontSize: "16px",
                    fontWeight: 400,
                    color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
                    width: "224px",
                  }}
                >
                  Device Type
                  <span style={{ color: "red", marginLeft: "5px" }}>*</span>
                </Typography>
                <CustomDropDown
                  options={type[1]}
                  onChange={handleDeviceTypeF}
                  /*disabled={props.deviceData.id!==""?true:false}*/ defaultValue={
                    props.deviceData.id !== ""
                      ? handletypename(props.deviceData.data.deviceType)
                      : type[1][typeIndex]
                  }
                ></CustomDropDown>
              </Box>
              <Box
                className="config-form-box"
                sx={{
                  padding: "4px 4px 4px 0px",
                  width: "33.33%",
                  boxSizing: "border-box",
                  marginTop: "12px",
                }}
              >
                <Typography
                  style={{
                    fontSize: "16px",
                    fontWeight: 400,
                    color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
                    width: "224px",
                  }}
                >
                  Device SubType
                  <span style={{ color: "red", marginLeft: "5px" }}>*</span>
                </Typography>
                <CustomDropDown
                  options={subtype[1][typeIndex]}
                  onChange={handleDeviceSubtypeF}
                  defaultValue={
                    props.deviceData.id !== "" &&
                    deviceInfo.data.deviceSubtype !== ""
                      ? handlesubtypename(deviceInfo.data.deviceSubtype)
                      : subtype[1][typeIndex][0]
                  }
                ></CustomDropDown>
              </Box>
              <Box
                className="config-form-box"
                sx={{
                  padding: "4px 4px 4px 0px",
                  width: "100%",
                  boxSizing: "border-box",
                  marginTop: "12px",
                }}
              >
                <Typography
                  style={{
                    fontSize: "16px",
                    fontWeight: 400,
                    color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
                    width: "224px",
                  }}
                >
                  Device Description
                </Typography>
                <CustomTextField
                  id={"negative-feedback"}
                  onChange={handleDeviceDescription}
                  defaultValue={
                    props.deviceData.id !== ""
                      ? props.deviceData.data.description
                      : deviceInfo.data.description
                  }
                  maxLength={250}
                  width={1297}
                />
              </Box>
              <Box
                className="config-form-box"
                sx={{
                  padding: "4px 4px 4px 0px",
                  width: "66.66%",
                  boxSizing: "border-box",
                  marginTop: "12px",
                }}
              >
                <Typography
                  style={{
                    fontSize: "16px",
                    fontWeight: 400,
                    color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
                    width: "224px",
                  }}
                >
                  Device Level
                </Typography>{" "}
                {/*Category*/}
                <CustomRadioButton
                  row={true}
                  onChange={handleDeviceCategory}
                  options={deviceCategory}
                  fontSize={16}
                  width={"calc(100% - 224px)"}
                  optionWidth={282}
                  defaultValue={
                    props.deviceData.id !== ""
                      ? props.deviceData.data.deviceCategory
                      : deviceInfo.data.deviceCategory !== ""
                        ? deviceInfo.data.deviceCategory
                        : deviceCategory[1][1]
                  }
                />
                {/* <CustomTextField id={'negative-feedback'} onChange={handleDeviceCategory}  defaultValue={props.deviceData.id!==""?props.deviceData.data.DeviceCategory:deviceInfo.data.DeviceCategory} maxLength={16} width={757}/>  */}
              </Box>
              <Box
                className="config-form-box"
                sx={{
                  padding: "4px 4px 4px 0px",
                  width: "33.33%",
                  boxSizing: "border-box",
                  marginTop: "12px",
                }}
              ></Box>
              {/* <Box className="config-form-box" sx={{padding:"4px 4px 4px 0px",width:"33.33%",boxSizing:'border-box',marginTop:"12px"}}></Box> */}
              {/* Meter  || props.deviceData.id===""*/}
              {meter === 1 ? (
                <>
                  <Box
                    className="config-form-box"
                    sx={{
                      padding: "4px 4px 4px 0px",
                      width: "33.33%",
                      boxSizing: "border-box",
                      marginTop: "12px",
                    }}
                  >
                    <Typography
                      style={{
                        fontSize: "16px",
                        fontWeight: 400,
                        color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
                        width: "224px",
                      }}
                    >
                      Meter Type
                      <span style={{ color: "red", marginLeft: "5px" }}>*</span>
                    </Typography>
                    <CustomDropDown
                      options={meterType}
                      onChange={handleMeterType}
                      /*disabled={props.deviceData.id!==""?true:false}*/ defaultValue={
                        props.deviceData.id !== "" &&
                        props.deviceData.data.meterType !== undefined
                          ? props.deviceData.data.meterType
                          : meterType[0]
                      }
                    ></CustomDropDown>
                  </Box>
                  <Box
                    className="config-form-box"
                    sx={{
                      padding: "4px 4px 4px 0px",
                      width: "33.33%",
                      boxSizing: "border-box",
                      marginTop: "12px",
                    }}
                  >
                    <Typography
                      style={{
                        fontSize: "16px",
                        fontWeight: 400,
                        color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
                        width: "224px",
                      }}
                    >
                      Phase Type
                      <span style={{ color: "red", marginLeft: "5px" }}>
                        {virtualOption === "true" ? "" : "*"}
                      </span>
                    </Typography>
                    <CustomDropDown
                      options={phaseType}
                      onChange={handlePhaseType}
                      /*disabled={props.deviceData.id!==""?true:false}*/ defaultValue={
                        props.deviceData.id !== "" &&
                        props.deviceData.data.phaseType !== undefined
                          ? props.deviceData.data.phaseType
                          : phaseType[0]
                      }
                    ></CustomDropDown>
                  </Box>
                  <Box
                    className="config-form-box"
                    sx={{
                      padding: "4px 4px 4px 0px",
                      width: "33.33%",
                      boxSizing: "border-box",
                      marginTop: "12px",
                    }}
                  >
                    <Typography
                      style={{
                        fontSize: "16px",
                        fontWeight: 400,
                        color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
                        width: "224px",
                      }}
                    >
                      Final Reading
                    </Typography>
                    <CustomTextField
                      id={"negative-feedback"}
                      onChange={handleFinalReading}
                      defaultValue={
                        props.deviceData.id !== ""
                          ? props.deviceData.data.finalReading
                          : deviceInfo.data.finalReading
                      }
                      /*permittedCharacters={'^-?\\d*(\\.?\\d*)?$'} errorText={"Only numeric characters are allowed"}*/ maxLength={
                        16
                      }
                      width={224}
                      permittedCharacters={"^[0-9]+(\\.[0-9]*)?$"}
                      errorText={"Only numeric characters are allowed"}
                    />
                  </Box>
                </>
              ) : (
                <></>
              )}
              <Box
                className="config-form-box"
                sx={{
                  padding: "4px 4px 4px 0px",
                  width: "33.33%",
                  boxSizing: "border-box",
                  marginTop: "12px",
                }}
              >
                <Typography
                  style={{
                    fontSize: "16px",
                    fontWeight: 400,
                    color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
                    width: "224px",
                  }}
                >
                  Device Make
                  <span style={{ color: "red", marginLeft: "5px" }}>
                    {virtualOption === "true" ? "" : "*"}
                  </span>
                </Typography>
                <CustomTextField
                  id={"negative-feedback"}
                  onChange={handleDeviceMake}
                  defaultValue={
                    props.deviceData.id !== ""
                      ? props.deviceData.data.make
                      : deviceInfo.data.make
                  }
                  maxLength={250}
                  width={224}
                  permittedCharacters={"^[a-zA-Z0-9][a-zA-Z0-9_]*$"}
                  errorText={"Only alphanumeric and '_' characters are allowed"}
                />
              </Box>
              <Box
                className="config-form-box"
                sx={{
                  padding: "4px 4px 4px 0px",
                  width: "33.33%",
                  boxSizing: "border-box",
                  marginTop: "12px",
                }}
              >
                <Typography
                  style={{
                    fontSize: "16px",
                    fontWeight: 400,
                    color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
                    width: "224px",
                  }}
                >
                  Device Model
                  <span style={{ color: "red", marginLeft: "5px" }}>
                    {virtualOption === "true" ? "" : "*"}
                  </span>
                </Typography>
                <CustomTextField
                  id={"negative-feedback"}
                  onChange={handleDeviceModel}
                  defaultValue={
                    props.deviceData.id !== ""
                      ? props.deviceData.data.model
                      : deviceInfo.data.model
                  }
                  maxLength={250}
                  width={224}
                  permittedCharacters={"^[a-zA-Z0-9][a-zA-Z0-9_]*$"}
                  errorText={"Only alphanumeric and '_' characters are allowed"}
                />
              </Box>
              <Box
                className="config-form-box"
                sx={{
                  padding: "4px 4px 4px 0px",
                  width: "33.33%",
                  boxSizing: "border-box",
                  marginTop: "12px",
                }}
              >
                <Typography
                  style={{
                    fontSize: "16px",
                    fontWeight: 400,
                    color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
                    width: "224px",
                  }}
                >
                  Device Firmware
                </Typography>
                <CustomTextField
                  id={"negative-feedback"}
                  onChange={handleDeviceFirmware}
                  defaultValue={
                    props.deviceData.id !== ""
                      ? props.deviceData.data.firmware
                      : deviceInfo.data.firmware
                  }
                  maxLength={250}
                  width={224}
                  permittedCharacters={"^[a-zA-Z0-9][a-zA-Z0-9_.]*$"}
                  errorText={"Only alphanumeric, '_' and '.' characters are allowed"}
                />
              </Box>
              <Box
                className="config-form-box"
                sx={{
                  padding: "4px 4px 4px 0px",
                  width: "33.33%",
                  boxSizing: "border-box",
                  marginTop: "12px",
                }}
              >
                <Typography
                  style={{
                    fontSize: "16px",
                    fontWeight: 400,
                    color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
                    width: "224px",
                  }}
                >
                  Commission Date
                  {/*<span style={{ color: "red", marginLeft: "5px" }}>*</span>*/}
                </Typography>
                {/* <DatePicker defaultValue={dayjs('25/10/2024', dateFormatList[0])} format={dateFormatList} variant='borderless' style={{color:theme==='dark'?'#C1C1C1':'#3C3C3C'}} onchange={handleCommissionDate} /> */}
                <CustomDatePicker
                  name={"devices"}
                  onChange={handleCommissionDate}
                  views={["day", "month", "year"]}
                  width={224}
                  defaultValue={
                    props.deviceData.id !== ""
                      ? dayjs(props.deviceData.data.commissionDate)
                      : dayjs(deviceInfo.data.commissionDate)
                  }
                  placeholder={"DD/MM/YYYY"}
                />
                {/* <CustomDropDown options={date} onChange={handleCommissionDate} /*disabled={props.deviceData.id!==""?true:false}* defaultValue={props.deviceData.id!==""?props.deviceData.data.commissionDate:date[0]}></CustomDropDown>*/}
              </Box>
              <Box
                className="config-form-box"
                sx={{
                  padding: "4px 4px 4px 0px",
                  width: "33.33%",
                  boxSizing: "border-box",
                  marginTop: "12px",
                }}
              >
                <Typography
                  style={{
                    fontSize: "16px",
                    fontWeight: 400,
                    color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
                    width: "224px",
                  }}
                >
                  Decommission Date
                  {/*<span style={{ color: "red", marginLeft: "5px" }}>*</span>*/}
                </Typography>
                <CustomDatePicker
                  name={"devices"}
                  onChange={handleDecommissionDate}
                  views={["day", "month", "year"]}
                  width={224}
                  defaultValue={
                    props.deviceData.id !== ""
                      ? dayjs(props.deviceData.data.decommissionDate)
                      : dayjs(deviceInfo.data.decommissionDate)
                  }
                  placeholder={"DD/MM/YYYY"}
                />
              </Box>
            </Box>
          ) : (
            <></>
          )}
          {virtualOption === "true" ? (
            <></>
          ) : (
            <>
              <Typography
                className="config-heading"
                style={{
                  fontSize: "20px",
                  fontWeight: 400,
                  color: "#008CD7",
                  padding: "4px",
                  marginTop: "20px",
                }}
              >
                Associated Gateway Details
                <Button
                  onClick={() => {
                    associatedGatewayDetails === 1
                      ? setAssociatedGatewayDetails(0)
                      : setAssociatedGatewayDetails(1);
                  }}
                >
                  {associatedGatewayDetails === 1 ? (
                    <ExpandLessOutlinedIcon
                      style={{
                        width: "28px",
                        height: "28px",
                        fontWeight: 700,
                        color: "#008CD7",
                      }}
                    />
                  ) : (
                    <ExpandMoreOutlinedIcon
                      style={{
                        width: "28px",
                        height: "28px",
                        fontWeight: 700,
                        color: "#008CD7",
                      }}
                    />
                  )}
                </Button>
              </Typography>
              {associatedGatewayDetails === 1 ? (
                <Box
                  style={{ overflow: "auto" }}
                  sx={{
                    display: "flex",
                    gap: "0px",
                    flexWrap: "wrap",
                    padding: "4px 4px 12px 4px",
                    backgroundColor:
                      theme === "dark" ? "#3C3C3C40" : "#FFFFFF80",
                  }}
                >
                  <Box
                    className="config-form-box"
                    sx={{
                      padding: "4px 4px 4px 0px",
                      width: "33.33%",
                      boxSizing: "border-box",
                      marginTop: "12px",
                    }}
                  >
                    <Typography
                      style={{
                        fontSize: "16px",
                        fontWeight: 400,
                        color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
                        width: "224px",
                      }}
                    >
                      Gateway
                    </Typography>
                    <CustomDropDown
                      options={gatewayList}
                      onChange={handleAssociatedGateway}
                      /*disabled={props.deviceData.id!==""?true:false}*/ defaultValue={
                        props.deviceData.id !== "" ||
                        props.deviceData.data.deviceName.includes("_clone")
                          ? gateway
                          : gatewayList[0]
                      }
                    ></CustomDropDown>
                  </Box>
                </Box>
              ) : (
                <></>
              )}
            </>
          )}
          <Typography
            className="config-heading"
            style={{
              fontSize: "20px",
              fontWeight: 400,
              color: "#008CD7",
              padding: "4px",
              marginTop: "20px",
            }}
          >
            Connection Details
            <Button
              onClick={() => {
                connectionDetails === 1
                  ? setConnectionDetails(0)
                  : setConnectionDetails(1);
              }}
            >
              {connectionDetails === 1 ? (
                <ExpandLessOutlinedIcon
                  style={{
                    width: "28px",
                    height: "28px",
                    fontWeight: 700,
                    color: "#008CD7",
                  }}
                />
              ) : (
                <ExpandMoreOutlinedIcon
                  style={{
                    width: "28px",
                    height: "28px",
                    fontWeight: 700,
                    color: "#008CD7",
                  }}
                />
              )}
            </Button>
          </Typography>
          {connectionDetails === 1 ? (
            <Box
              style={{ overflow: "auto" }}
              sx={{
                display: "flex",
                gap: "0px",
                flexWrap: "wrap",
                padding: "4px 4px 12px 4px",
                backgroundColor: theme === "dark" ? "#3C3C3C40" : "#FFFFFF80",
              }}
            >
              <Box
                className="config-form-box"
                sx={{
                  padding: "4px 4px 4px 0px",
                  width: "33.33%",
                  boxSizing: "border-box",
                  marginTop: "12px",
                }}
              >
                <Box
                  className="config-form-box"
                  style={{ gap: 0, marginTop: 0 }}
                >
                  <Box style={{ marginTop: "-2.05px" }}>
                    <CustomCheckbox
                      defaultChecked={
                        props.deviceData.id !== ""
                          ? props.deviceData.data.enable
                          : deviceInfo.data.enable
                      }
                      onChange={handleDeviceEnable}
                    ></CustomCheckbox>
                  </Box>
                  <Typography
                    style={{
                      fontSize: "16px",
                      fontWeight: 400,
                      color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
                      width: "224px",
                      marginLeft: "8px",
                    }}
                  >
                    {" "}
                    Enable Device
                  </Typography>
                </Box>
              </Box>
              {virtualOption === "true" ? (
                <></>
              ) : (
                <Box
                  className="config-form-box"
                  sx={{
                    padding: "4px 4px 4px 0px",
                    width: "33.33%",
                    boxSizing: "border-box",
                    marginTop: "12px",
                  }}
                >
                  <Typography
                    style={{
                      fontSize: "16px",
                      fontWeight: 400,
                      color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
                      width: "224px",
                    }}
                  >
                    Connection State
                  </Typography>
                  <Box
                    className="config-form-box"
                    style={{ gap: 0, marginTop: 0 }}
                  >
                    <Typography
                      style={{
                        fontSize: "16px",
                        fontWeight: 400,
                        color: props.deviceData.data.enable
                          ? handleConnectionStatus(
                              props.deviceData.id,
                              connState,
                            ) === true
                            ? "#00943d"
                            : "#dc272d"
                          : "#dc272d",
                      }}
                    >
                      {(props.deviceData.data.enable === "true" ||
                        props.deviceData.data.enable === true) &&
                      props.deviceData.id !== ""
                        ? handleConnectionStatus(
                            props.deviceData.id,
                            connState,
                          ) === true
                          ? "Connected"
                          : "Not Connected"
                        : "Not Connected"}
                    </Typography>
                  </Box>
                </Box>
              )}
            </Box>
          ) : (
            <></>
          )}
          <Typography
            className="config-heading"
            style={{
              fontSize: "20px",
              fontWeight: 400,
              color: "#008CD7",
              padding: "4px",
              marginTop: "20px",
            }}
          >
            Parameter Details
            <Button
              onClick={() => {
                parameterDetails === 1
                  ? setParameterDetails(0)
                  : setParameterDetails(1);
              }}
            >
              {parameterDetails === 1 ? (
                <ExpandLessOutlinedIcon
                  style={{
                    width: "28px",
                    height: "28px",
                    fontWeight: 700,
                    color: "#008CD7",
                  }}
                />
              ) : (
                <ExpandMoreOutlinedIcon
                  style={{
                    width: "28px",
                    height: "28px",
                    fontWeight: 700,
                    color: "#008CD7",
                  }}
                />
              )}
            </Button>
          </Typography>
          {parameterDetails === 1 ? (
            <Box
              style={{ width: "100%", boxSizing: "border-box", height: "auto" }}
            >
              <EditableTable
                data={
                  props.deviceData.data.parameters.length > 0
                    ? props.deviceData.data.parameters
                    : []
                }
                setdata={handleParameter}
                deviceId={props.deviceData.id}
                enabled={props.deviceData.data.enable}
                connstate={handleConnectionState}
                getdeleteTags={handleDeleteTagsF}
                units={unitandDatatype.unitsList}
                datatypes={unitandDatatype.dataTypesList}
                storageGroupsList={storageGroups}
                virtualDevice={virtualOption}
                tagConfig={tagConfiguration}
              />
            </Box>
          ) : (
            <></>
          )}
        </Box>
      </Box>
    );
  };

  return (
    <Box
      className="compliance-config"
      sx={{ height: "100%", boxSizing: "border-box", width: "100%" }}
    >
      {/* <CustomToast message={"hi"} open1={openToast === 1? true : true} color={"pink"}/> */}
      {saveStatus !== 0 ? (
        <CustomToast
          openToast={saveStatus !== 0}
          type={saveStatus === 1 ? "Success" : "Error"}
          autoHideDuration={10000}
          toastText={saveStatus === 1 ? "Saved Successfully!" : "Save Failed"}
          onClose={handleToastClose}
        />
      ) : (
        <></>
      )}
      {deleteSuccess !== 0 ? (
        <CustomToast
          openToast={deleteSuccess !== 0}
          type={deleteSuccess === 1 ? "Success" : "Error"}
          toastText={
            deleteSuccess === 1 ? "Deleted Successfully!" : "Delete Failed"
          }
          onClose={handleDeleteToastClose}
        />
      ) : (
        <></>
      )}
      <CustomToast openToast={copyStatus!==0} type={"Success"} toastText={"Copied Successfully!"} onClose={() => setCopyStatus(0)}/>
      <Box
        sx={{
          padding: "0px",
          height: "calc(100% - 0px)",
          width: "100%",
          boxSizing: "border-box",
        }}
      >
        <Box
          sx={{
            padding: "0px",
            width: "100%",
            height: "7%",
            boxSizing: "border-box",
            display: "flex",
          }}
        >
          {openForm === 0 ? (
            <>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  width: "100%",
                  fontSize: "16px",
                  fontFamily: "Roboto",
                  margin: "0px",
                  alignSelf: "center",
                }}
              >
                <Typography
                  className="config-heading"
                  style={{
                    fontSize: "16px",
                    fontWeight: 400,
                    color: "var(--GreyVariation_4)",
                    marginRight: "12px",
                    alignContent: "end",
                  }}
                >
                  Total
                </Typography>
                <Typography
                  className="config-heading"
                  style={{
                    fontSize: "20px",
                    fontWeight: 400,
                    color: "var(--PrimaryText)",
                    marginRight: "40px",
                  }}
                >
                  {deviceno.length}
                </Typography>
                <Typography
                  className="config-heading"
                  style={{
                    fontSize: "16px",
                    fontWeight: 400,
                    color: "var(--GreyVariation_4)",
                    marginRight: "12px",
                    alignContent: "end",
                  }}
                >
                  Enabled
                </Typography>
                <Typography
                  className="config-heading"
                  style={{
                    fontSize: "20px",
                    fontWeight: 400,
                    color: "var(--GreyVariation_3)",
                    marginRight: "20px",
                  }}
                >
                  {
                    deviceno.filter(
                      (deviceno) =>
                        deviceno.data.enable === "true" ||
                        deviceno.data.enable === true,
                    ).length
                  }
                </Typography>
                <Typography
                  className="config-heading"
                  style={{
                    fontSize: "16px",
                    fontWeight: 400,
                    color: "var(--GreyVariation_4)",
                    marginRight: "12px",
                    alignContent: "end",
                  }}
                >
                  Connected
                </Typography>
                <Typography
                  className="config-heading"
                  style={{
                    fontSize: "20px",
                    fontWeight: 400,
                    color: "var(--GreenBaseColor)",
                    marginRight: "20px",
                  }}
                >
                  {connState.filter((value) => value[1] === "Connected").length}
                </Typography>
                <Typography
                  className="config-heading"
                  style={{
                    fontSize: "16px",
                    fontWeight: 400,
                    color: "var(--GreyVariation_4)",
                    marginRight: "12px",
                    alignContent: "end",
                  }}
                >
                  Not Connected
                </Typography>
                <Typography
                  className="config-heading"
                  style={{
                    fontSize: "20px",
                    fontWeight: 400,
                    color: "var(--RedBaseColor)",
                    marginRight: "20px",
                  }}
                >
                  {connState.filter((value) => value[1] !== "Connected").length}
                </Typography>
              </Box>
              <Box
                sx={{ flexGrow: 1, height: "24px", alignSelf: "center" }}
              ></Box>
              <CustomTooltip
                title={"Refresh"}
                offset={[30, -20]}
                placement={"right-end"}
              >
                <Button
                  onClick={handleRefresh}
                  disabled={disableButtons !== 0 ? true : false}
                  sx={{
                    width: "40px",
                    "& .MuiButtonBase-root.MuiButton-root": { width: "40px" },
                    padding: 0,
                  }}
                  style={{
                    fontSize: "12px",
                    height: "28px",
                    minWidth: "44px",
                    width: "40px",
                    fontWeight: 400,
                    alignSelf: "center",
                    marginLeft: "auto",
                    marginRight: "auto",
                    marginTop: "-8px",
                  }}
                >
                  <LK_Refresh
                    color={
                      disableButtons !== 0
                        ? theme === "light"
                          ? "#C1C1C1"
                          : "#3C3C3C"
                        : "var(--HighlightedText_Stroke)"
                    }
                    width={"28px"}
                    height={"28px"}
                  />
                </Button>
              </CustomTooltip>
              <CustomTooltip
                title={"Add"}
                offset={[30, -20]}
                placement={"right-end"}
              >
                <Button
                  onClick={() => setOpenForm(1)}
                  disabled={disableButtons !== 0 ? true : false}
                  sx={{
                    width: "40px",
                    "& .MuiButtonBase-root.MuiButton-root": { width: "40px" },
                    padding: 0,
                  }}
                  style={{
                    fontSize: "12px",
                    height: "28px",
                    width: "40px",
                    minWidth: "44px",
                    fontWeight: 400,
                    alignSelf: "center",
                    marginLeft: "auto",
                    marginRight: "auto",
                    marginTop: "-8px",
                  }}
                >
                  <LK_Add
                    color={
                      disableButtons !== 0
                        ? theme === "light"
                          ? "#C1C1C1"
                          : "#3C3C3C"
                        : "var(--HighlightedText_Stroke)"
                    }
                    width={"28px"}
                    height={"28px"}
                  />
                </Button>
              </CustomTooltip>
              <CustomTooltip
                title={"Select All"}
                offset={[30, -20]}
                placement={"right-end"}
              >
                <Button
                  onClick={handleSelectAllDevices}
                  disabled={
                    disableButtons !== 0 && disableButtons !== 1 ? true : false
                  }
                  style={{
                    fontSize: "12px",
                    height: "40px",
                    width: "40px",
                    minWidth: "40px",
                    fontWeight: 400,
                    alignSelf: "center",
                    marginLeft: "-0px",
                    marginRight: "0",
                    marginTop: "-8px",
                  }}
                >
                  <LK_Select
                    color={
                      disableButtons !== 0 && disableButtons !== 1
                        ? theme === "light"
                          ? "#C1C1C1"
                          : "#3C3C3C"
                        : "var(--HighlightedText_Stroke)"
                    }
                    width={"36px"}
                    height={"36px"}
                  />
                </Button>
              </CustomTooltip>
              <CustomTooltip
                title={"Delete"}
                offset={[30, -20]}
                placement={"right-end"}
              >
                <Button
                  onClick={handleDeleteSelected}
                  disabled={
                    disableButtons !== 0 && disableButtons !== 1 ? true : false
                  }
                  sx={{
                    width: "40px",
                    "& .MuiButtonBase-root.MuiButton-root": { width: "40px" },
                    padding: 0,
                  }}
                  style={{
                    fontSize: "12px",
                    height: "36px",
                    width: "36px",
                    minWidth: "36px",
                    boxSizing: "border-box",
                    fontWeight: 400,
                    alignSelf: "center",
                    marginLeft: "-4px",
                    marginRight: "0",
                    marginTop: "-8px",
                  }}
                >
                  <LK_Delete
                    color={
                      disableButtons !== 0 && disableButtons !== 1
                        ? theme === "light"
                          ? "#C1C1C1"
                          : "#3C3C3C"
                        : "var(--HighlightedText_Stroke)"
                    }
                    width={"36px"}
                    height={"36px"}
                  />
                </Button>
              </CustomTooltip>
              {/* <CustomDialogBox dialogTitle={"Delete Conformation"} dialogText={"Are you sure you want to delete "+ deleteDeviceArr.length + " devices"} openDialog={deleteConfimed===1} handleCloseDialog={handleDeleteCancel} handleConfirmDialog={handleDeleteConfirmed} confirmText={"OK"} cancelText={"Cancel"}/>
                        <CustomDialogBox dialogTitle={"Delete Conformation"} dialogText={"Please selecte devices for deletion"} openDialog={deleteConfimed===2} handleCloseDialog={handleDeleteCancel} handleConfirmDialog={()=>{setDeleteConfirmed(0)}} confirmText={"OK"} cancelText={"Cancel"}/> */}
              <CustomDialogBox
                dialogTitle={"Delete Conformation"}
                dialogText={
                  "Are you sure you want to delete " +
                  deleteDeviceArr.length +
                  " device" +
                  (deleteDeviceArr.length > 1 ? "s" : "")
                }
                openDialog={deleteConfimed === 1}
                handleCloseDialog={handleDeleteCancel}
                handleConfirmDialog={handleDeleteConfirmed}
                confirmText={"OK"}
                cancelText={"Cancel"}
                type={"Warning"}
              />
              <CustomDialogBox
                dialogTitle={"Delete Conformation"}
                dialogText={"Please select devices for deletion"}
                openDialog={deleteConfimed === 2}
                handleCloseDialog={handleDeleteCancel}
                handleConfirmDialog={() => {
                  setDeleteConfirmed(0);
                }}
                confirmText={"OK"}
                cancelText={"Cancel"}
                type={"Warning"}
              />
              <CustomDialogBox dialogTitle={"No Devices Selected"} dialogText={"No Devices selected for deselection"} openDialog={deleteConfimed===3} handleCloseDialog={()=>{setDeleteConfirmed(0)}} handleConfirmDialog={()=>{setDeleteConfirmed(0)}} confirmText={"OK"} cancelText={"Cancel"} type={"Warning"}/>
              <CustomTooltip
                title={"Deselect All"}
                offset={[30, -20]}
                placement={"right-end"}
              >
                <Button
                  onClick={handleDeleteCancel}
                  disabled={
                    disableButtons !== 0 && disableButtons !== 1 ? true : false
                  }
                  style={{
                    fontSize: "12px",
                    height: "28px",
                    width: "40px",
                    minWidth: "44px",
                    fontWeight: 400,
                    alignSelf: "center",
                    marginLeft: "-6px",
                    marginRight: "0",
                    marginTop: "-8px",
                  }}
                >
                  <LK_Close
                    color={
                      disableButtons !== 0 && disableButtons !== 1
                        ? theme === "light"
                          ? "#C1C1C1"
                          : "#3C3C3C"
                        : "var(--HighlightedText_Stroke)"
                    }
                    width={"24px"}
                    height={"24px"}
                  />
                </Button>
              </CustomTooltip>
              {/* {deleteDevice!=true?
                            <Button onClick={()=>setDeleteDevice(1)} style={{ fontSize: '12px',height:'28px',width:'40px', fontWeight: 400,alignSelf:"center",marginLeft:"-20px",marginRight:"auto",marginTop:'-8px'}}><LK_Delete color='var(--LK_BrandBlue)' width={"36px"} height={"36px"}/></Button>
                            :
                            <>
                                <Button onClick={handleDeleteSelected} style={{ fontSize: '12px',height:'28px',width:'40px', fontWeight: 400,alignSelf:"center",marginLeft:"-20px",marginRight:"0",marginTop:'-8px'}}><LK_Select color='var(--LK_BrandBlue)' width={"28px"} height={"px"}/></Button>
                                {/* <Button onClick={handleDeleteSelected} style={{ fontSize: '12px',height:'28px',width:'40px', fontWeight: 400,alignSelf:"center",marginLeft:"-20px",marginRight:"0",marginTop:'-8px'}}><LK_Delete color='var(--LK_BrandBlue)' width={"36px"} height={"36px"}/></Button> /}
                                <Button onClick={handleDeleteSelected} style={{ fontSize: '12px',height:'28px',width:'40px', fontWeight: 400,alignSelf:"center",marginLeft:"-20px",marginRight:"0",marginTop:'-8px'}}><LK_Delete color='var(--LK_BrandBlue)' width={"36px"} height={"36px"}/></Button>
                                <CustomDialogBox dialogTitle={"Delete Conformation"} dialogText={"Are you sure you want to delete "+ deleteDeviceArr.length + " devices"} openDialog={deleteConfimed===1} handleCloseDialog={handleDeleteCancel} handleConfirmDialog={handleDeleteConfirmed} confirmText={"OK"} cancelText={"Cancel"}/>
                                <CustomDialogBox dialogTitle={"Delete Conformation"} dialogText={"Please selecte devices for deletion"} openDialog={deleteConfimed===2} handleCloseDialog={handleDeleteCancel} handleConfirmDialog={()=>{setDeleteConfirmed(0)}} confirmText={"OK"} cancelText={"Cancel"}/>
                                <Button onClick={handleDeleteCancel} style={{ fontSize: '12px',height:'28px',width:'40px', fontWeight: 400,alignSelf:"center",marginLeft:"-20px",marginRight:"0",marginTop:'-8px'}}><LK_Close color='var(--LK_BrandBlue)' width={"24px"} height={"24px"}/></Button>
                            </>
                        } */}
              {/* <Box style={{ fontSize: '12px',width:"150px",height:'20px',alignSelf:"center" }}></Box> */}
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  width: "30%",
                  fontSize: "16px",
                  fontFamily: "Roboto",
                  marginTop: "-4px",
                  alignSelf: "center",
                  gap: "8px",
                  alignItems: "center",
                }}
              >
                <CustomTextField
                  id={"negative-feedback"}
                  onChange={handleSearchText}
                  disabled={
                    disableButtons !== 0 && disableButtons !== 1 ? true : false
                  }
                  defaultValue={ifsearching === 0 ? "" : search.searchText}
                  placeholder={"search"}
                  width={180}
                />
                <CustomDropDown
                  options={filter}
                  onChange={handleFilterSelected}
                  disabled={
                    disableButtons !== 0 && disableButtons !== 1 ? true : false
                  }
                  defaultValue={ifsearching === 0 ? "" : search.searchText}
                  width={"180px"}
                ></CustomDropDown>
                <CustomTooltip
                  title={"Search"}
                  offset={[30, -20]}
                  placement={"right-end"}
                >
                  <Button
                    onClick={handleSearchClick}
                    style={{
                      fontSize: "12px",
                      width: "40px",
                      minWidth: "40px",
                      fontWeight: 400,
                      color: "var(--Searchtext_muted)",
                      fontFamily: "Roboto",
                      textAlign: "left",
                      justifySelf: "right",
                      cursor: "pointer",
                      textTransform: "none",
                      marginLeft: "0px",
                      padding: 0,
                    }}
                  >
                    <LK_Search
                      color={
                        disableButtons !== 0 && disableButtons !== 1
                          ? theme === "light"
                            ? "#C1C1C1"
                            : "#3C3C3C"
                          : "var(--HighlightedText_Stroke)"
                      }
                      width={"28px"}
                      height={"28px"}
                    />
                  </Button>
                </CustomTooltip>
                {ifsearching === 1 ? (
                  <Button
                    onClick={handleSearchCancel}
                    style={{
                      fontSize: "12px",
                      width: "34px",
                      minWidth: "34px",
                      fontWeight: 400,
                      color: "var(--Searchtext_muted)",
                      fontFamily: "Roboto",
                      textAlign: "left",
                      justifySelf: "right",
                      cursor: "pointer",
                      textTransform: "none",
                      marginLeft: "-8px",
                      padding: 0,
                    }}
                  >
                    <LK_Close
                      color={
                        disableButtons !== 0 && disableButtons !== 1
                          ? theme === "light"
                            ? "#C1C1C1"
                            : "#3C3C3C"
                          : "var(--HighlightedText_Stroke)"
                      }
                      width={"24px"}
                      height={"24px"}
                    />
                  </Button>
                ) : (
                  <></>
                )}
              </Box>
              {/* <Button  style={{ fontSize: '12px',width:"150px",height:'20px', fontWeight: 400, color: 'var(--Searchtext_muted)', fontFamily: 'Roboto', textAlign:'left',justifySelf:"right",cursor: 'pointer',textTransform:'none' ,marginLeft:"auto",alignSelf:"center"}}>filter<Typography sx={{marginLeft:"60px"}}>v</Typography></Button>  */}
            </>
          ) : (
            <>
              <Box
                sx={{
                  display: "flex",
                  gap: "8px",
                  width: "100%",
                  height: "100%",
                }}
              >
                <Box sx={{ flexGrow: 1 }}></Box>
                <CustomDialogBox
                  dialogTitle={"Required fields not filled"}
                  dialogText={"Required fields to must be filled"}
                  openDialog={required === 1}
                  handleCloseDialog={() => setRequired(0)}
                  handleConfirmDialog={() => setRequired(0)}
                  confirmText={"OK"}
                  cancelText={"Cancel"}
                  type={"Warning"}
                />
                <CustomDialogBox
                  dialogTitle={"Device name already in use"}
                  dialogText={"This device name is already in use"}
                  openDialog={required === 2}
                  handleCloseDialog={() => setRequired(0)}
                  handleConfirmDialog={() => setRequired(0)}
                  confirmText={"OK"}
                  cancelText={"Cancel"}
                  type={"Warning"}
                />
                <CustomCancelButton
                  onClick={handleCloseAddForm}
                  buttonText={"Cancel"}
                ></CustomCancelButton>
                {/* <Button id={props.index} onClick={props.saveForm}>Save</Button> */}
                <CustomButton
                  id={deviceInfo.id}
                  onClick={handleSaveAddForm}
                  buttonText={"Save"}
                  width={"12px"}
                />
              </Box>
            </>
          )}
        </Box>
        <Box
          sx={{
            boxSizing: "border-box",
            padding: "8px",
            background: "var(--PrimaryBackground)",
            height: "calc(93%)",
            marginBottom: "0px",
            overflow: "auto",
          }}
        >
          {loading === 0 ? (
            <>
              {openForm === 0 ? (
                <>
                  <Box
                    sx={{
                      display: "flex",
                      gap: "8px",
                      flexWrap: "wrap",
                      boxSizing: "border-box",
                      height: "calc(100%)",
                      overflow: "auto",
                      alignContent: "flex-start",
                    }}
                  >
                    {ifsearching === 0 ? (
                      <>
                        {deviceno.map((val, index) => (
                          <>
                            {console.log("devicecard", val)}
                            <DeviceCard index={index} devicelist={val} />
                          </>
                        ))}
                      </>
                    ) : (
                      <>
                        {searchList.length === 0 ? (
                          <>
                            <Typography
                              className="config-heading"
                              style={{
                                fontSize: "40px",
                                fontWeight: 700,
                                color: "var(--GreyBaseColor)",
                                marginRight: "20px",
                                justifySelf: "flex-end",
                                justifyItems: "center",
                                justifyContent: "center",
                                justifyTracks: "center",
                              }}
                            >
                              No Match Found
                            </Typography>
                          </>
                        ) : (
                          <>
                            {searchList.map((val, index) => (
                              <DeviceCard index={index} devicelist={val} />
                            ))}
                          </>
                        )}
                      </>
                    )}
                  </Box>
                </>
              ) : (
                <Box
                  sx={{
                    display: "flex",
                    gap: "8px",
                    flexWrap: "wrap",
                    height: "100%",
                    boxSizing: "border-box",
                  }}
                >
                  <DeviceForm
                    /*formType={"Add"} openForm={openAddForm}**/ closeForm={
                      handleCloseAddForm
                    }
                    saveForm={handleSaveAddForm}
                    deviceData={deviceInfo}
                  />
                </Box>
              )}
            </>
          ) : (
            <Box
              sx={{
                gap: "8px",
                boxSizing: "border-box",
                height: "calc(100%)",
                width: "100%",
                overflow: "auto",
                alignContent: "center",
              }}
            >
              <img
                src={LK_Loading}
                alt="loading..."
                style={{ height: "15%", width: "auto", alignSelf: "center" }}
              />
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
}
